/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from "react";

// Chakra imports
import {
  Flex,
  Box,
  Image,
  Button,
  IconButton,
  Icon,
  Text,
  Checkbox,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
  Divider,
  RadioGroup,
  Stack,
  Radio,
  Select,
  Table,
  Tbody,
  Textarea,
  Input,
  Tr,
  Td,
  CircularProgress,
} from "@chakra-ui/react";
import { TabIndicator } from "@chakra-ui/react";

// Custom components
import Card from "components/card/Card";
import { api } from "api";

import Mastercard from "components/card/Mastercard";
import Transaction from "components/dataDisplay/Transaction";
import TransactionMacae from "components/dataDisplay/TransactionMacae";
import {
  buscarHistoricoExtrato,
  buscarLojasNaAPI,
  buscar2Via,
  buscarHistoricoExtratoMacae,
  finalizarPedidoCartaoAtendimento,
  getListaMotivosCancelamento,
  cancelamentoCartao,
  valor2Via,
  bloquearCartao,
  desbloquearCartao,
  buscarHistoricoPedidoCartao,
  associarCartaoApi,
  buscarLaudo,
  buscarTaxaEntrega,
  pesquisaCliente,
  pesquisarDataSenior,
  consultarPenalizacaoGratuidade,
  buscarRegrasPorGratuidade,
  consultarGratuidadeEstudante,
  cancelarPedidoApi,
  getBloqueioContas,
  buscarBloqueioConta,
  getLinhas,
  desbloqueioContaUsoIndevido,
} from "config/apis/requests";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { ca, de, id, is, pt } from "date-fns/locale";
import "assets/css/DatePickerRange.css";
import { isEmpty } from "@chakra-ui/utils";
import fakeGraph from "assets/img/dashboards/fakeGraph.png";

// Assets
import {
  MdCancelPresentation,
  MdDateRange,
  MdSearch,
  MdStore,
  MdCreditCardOff,
  MdCreditCard,
  MdOutlineClose,
  MdCompareArrows,
  MdError,
  MdOutlineCardGiftcard,
  MdOutlineAttachMoney,
  MdOutlineRemoveCircleOutline,
  MdFingerprint,
  MdOutlinePersonAddAlt1,
  MdUnpublished,
  MdOutlineAccessible,
  MdOutlinePolicy,
  MdPeopleAlt,
  MdAddCard,
  MdHome,
} from "react-icons/md";
import { HiOutlineCheck, HiXCircle } from "react-icons/hi";
import {
  maskNumeroMidia,
  formatCurrencyFloor,
  maskDataHistoricoSemHora,
  maskDataContaVirtual,
  IsEmpty,
  maskNumeroMidiaAssociada,
  removerTracos,
  formatarParaMoeda,
  formatDataTimeStamp,
  maskDataLaudoSemHora,
  maskDataLaudoSemHoraMaisUm,
  maskOnlyNumbers,
  getTipoPagamento,
  isDataCancelada,
  verificarSePossuiTaxaDeEntrega,
} from "config/functions";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import PopOverAlertOrange from "components/popAlert/popAlert";
import PopOverAlertGreen from "components/popAlert/popAlertSucess";
import InputField from "components/fields/InputField";
import PopOverAlert from "components/popAlert/popAlert";
import balanceImg from "assets/img/dashboards/balanceImg.png";
import { listarGratuidade } from "config/apis/requests";
import { Pedido } from "views/admin/atendimento/profile/components/ClientePedido";
import IconBox from "components/icons/IconBox";
import { atendenteAuditoria, estudante, pcd, senior } from "variables/charts";
import TransacoesFraude from "components/dataDisplay/TransacoesFraude";
import cancelado from "assets/img/dashboards/cancelado.png";
import { set } from "date-fns";
export default function ContaPrincipal(props: {
  midiasContaPrincipal?: any;
  solicitarCartao?: any;
  atualizaPedido?: any;
  enderecoAtualizar?: any;
  atualizaCartao?: any;
  codigoProdutoParaPedido?: any;
  cepUserNovo?: any;
  historicoGratuidadeEstudanteCartao?: any;
  historicoGratuidadeSeniorCartao?: any;
  historicoGratuidadePcdCartao?: any;
  [dataUser: string]: any;
}) {
  type Motivo = {
    id: number;
    idTipoAcao: TipoAcao;
    descricao: string;
  };
  enum MODAL_ENUM {
    desbloquearSaldo = "DESBLOQUEAR_SALDO",
    bloquearSaldo = "BLOQUEAR_SALDO",
    desbloquearConta = "DESBLOQUEAR_CONTA",
    bloquearConta = "BLOQUEAR_CONTA",
    bloquearMidia = "BLOQUEAR_MIDIA",
    desbloquearMidia = "DESBLOQUEAR_MIDIA",
  }
  const {
    midiasContaPrincipal,
    dataUser,
    atualizaCartao,
    solicitarCartao,
    codigoProdutoParaPedido,
    pesquisaHistoricoMidia,
    atualizaPedido,
    enderecoAtualizar,
    cepUserNovo,
    historicoGratuidadeEstudanteCartao,
    historicoGratuidadeSeniorCartao,
    historicoGratuidadePcdCartao,
  } = props;
  const [midias, setMidias] = useState([]);
  const [contaBloqueada, setContaBloqueada] = useState(false);
  const [contaBloqueadaEstudante, setContaBloqueadaEstudante] = useState(false);
  const [contaBloqueadaPcd, setContaBloqueadaPcd] = useState(false);
  const [contaBloqueadaSenior, setContaBloqueadaSenior] = useState(false);
  const [valorBloqueadoConta, setValorBloqueadoConta] = useState(false);
  const [listaModais, setListaModais] = useState<any[]>([]);
  const [listaMidias, setListaMidias] = useState([]);
  const [listaOperadoras, setListaOperadoras] = useState([]);
  const [valorBloqueadoContaIndevida, setValorBloqueadoContaIndevida] =
    useState(0);
  const [isSenior, setIsSenior] = useState(false);
  const [justificativa, setJustificativa] = useState("");
  const [limite, setLimite] = useState(0);
  const [limitePassagensEstudante, setLimitePassagensEstudante] = useState(0);
  const [acompanhante, setAcompanhante] = useState(false);
  const [dataFimValidadeRegraPcd, setDataFimValidadeRegraPcd] = useState(null);
  const [dataFimValidadeRegraEstudante, setDataFimValidadeRegraEstudante] =
    useState(null);
  const [valorAtualAcompanhantePCD, setValorAtualAcompanhantePCD] =
    useState(false);
  const [lojas, setLojas] = useState([]);
  const [motivos, setMotivos] = useState([]);
  const [lojaSelect, setLojaSelect] = useState(0);
  const [motivoSelect, setMotivoSelect] = useState(0);
  const [modalType, setModalType] = useState<MODAL_ENUM>(null);
  const [onViewRatioEndereco, setViewRatioEndereco] = useState("loja");
  const [boletimOcorrencia, setBoletimOcorrencia] = useState(false);
  const [viewPassoUm, setViewPassoUm] = useState(true);
  const textYelBg = useColorModeValue("yellow.500", "navy.300");
  const [atualizarCartao, setAtualizarCartao] = useState(false);
  const [viewBotaoProsseguir, setViewBotaoProsseguir] = useState(true);
  const textGrayBg = useColorModeValue("secondaryGray.900", "navy.700");
  const textVerdeBg = useColorModeValue("green.500", "navy.300");
  const textRedBg = useColorModeValue("red.500", "navy.300");
  const [valorPrimeiraVia, setValorPrimeiraVia] = useState("");
  const [valorSegundaVia, setValorSegundaVia] = useState("");
  const [biometria, setBiometria] = useState(false);
  const iconBoxBg = useColorModeValue("secondaryGray.300", "navy.700");
  const [modalData, setModalData] = useState(false);
  const [modalPedidoCancelamento, setModalPedidoCancelamento] = useState(false);
  const [fraude, setFraude] = useState(false);
  const [modalFinalizaCompra, setModalFinalizaCompra] = useState(false);
  const [modalUsoIndevido, setModalUsoIndevido] = useState(false);
  const [usoIndevido, setUsoIndevido] = useState(false);
  const [taxaEnvio, setTaxaEnvio] = useState("");
  const [nrSeqEndereco, setNrSeqEndereco] = useState(0);
  const [modalPedidoCartao, setModalPedidoCartao] = useState(false);
  const [modalAssociarCartao, setModalAssociarCartao] = useState(false);
  const [bloqueioModal, setBloqueioModal] = useState(false);
  const [historicoExtrato, setHistoricoExtrato] = useState([]);
  const [historicoExtratoMacae, setHistoricoExtratoMacae] = useState([]);
  const [temHistorico, setTemHistorico] = useState(false);
  const [isIlimitado, setIsIlimitado] = useState(false);
  const tabButtonRef = useRef([]);
  const bodyPedido = new Pedido();
  const [loadingDataTransacoes, setLoadingDataTransacoes] = useState(false);
  const [statusSegundaVia, setStatusSegundaVia] = useState(false);
  const [linhasList, setLinhasList] = useState<any[]>([]);
  const [contasBloqueadas, setContasBloqueadas] = useState([]);
  const [isOpenModalBloqueioIndevido, setIsOpenModalBloqueioIndevido] =
    useState(false);
  const [isCloseModalBloqueioIndevido, setIsCloseModalBloqueioIndevido] =
    useState(false);

  interface PerfisUsuario {
    perfis: string[];
  }
  interface dateRangeType {
    startDate: Date;
    endDate: Date;
  }
  const perfisConsultaEstudante = ["CONSULTA_ESTUDANTE", "CADASTRO_ESTUDANTE"];
  const recoverLoggedUser = [JSON.parse(localStorage.getItem("user"))];
  const usuarios: PerfisUsuario[] = [
    {
      perfis: recoverLoggedUser[0]?.perfis,
    },
  ];
  let dataLoginEndereco: any;
  const [enderecoTO, setEnderecoTO] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [laudo, setLaudo] = useState([]);

  const [logradouro, setLogradouro] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [numero, setNumero] = useState("");
  const [numeroCartaoAssociado, setNumeroCartaoAssociado] = useState("");
  const [metodoPagamento, setMetodoPagamento] = useState("");
  const [motivo, setMotivo] = useState(null);
  const [uf, setUf] = useState("");
  const [cep, setCep] = useState("");
  const [cepLoja, setCepLoja] = useState("");
  const [somaPesquisaUtilizacao, setSomaPesquisaUtilizacao] = useState(0.0);
  const [isOpenGreen, setIsOpenGreen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [msgStatusOk, setMsgStatusOk] = useState("");
  const [tipoErroPedido, setTipoErroPedido] = useState("");
  const [loading, setLoading] = useState(false);
  const [pedidoFeito, setPedidoFeito] = useState(false);
  const [podeAssociarCartao, setPodeAssociarCartao] = useState(false);
  const [loadingCancelamento, setLoadingCancelamento] = useState(false);
  const [loadingAssociar, setLoadingAssociar] = useState(false);
  const [tabState, setTabState] = useState(0);
  const [idProduto, setIdProduto] = useState(0);
  const [numeroPedido, setNumeroPedido] = useState(0);
  const [isOpenErro, setIsOpenErro] = useState(false);
  const [modalCancelamento, setModalCancelamento] = useState(false);
  const [cartaoCancelado, setCartaoCancelado] = useState("");
  const [buscaSete, setBuscaSete] = useState(true);
  const [valorBloqueado, setValorBloqueado] = useState(false);
  const [podeDesbloquarConta, setPodeDesbloquarConta] = useState(false);
  const [pedidoPrimeiraVia, setPedidoPrimeiraVia] = useState(false);
  const [pedidoSegundaVia, setPedidoSegundaVia] = useState(false);
  const [existePedido, setExistePedido] = useState(false);
  const [tipoPedidoCartao, setTipoPedidoCartao] = useState("");
  const [historicoGratuidade, setHistoricoGratuidade] = useState([]);
  const [penalizacaoGratuidade, setPenalizacaoGratuidade] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [showFixedDate, setShowFixedDate] = useState(true);
  const handleOpenAlert = (status: boolean) => {
    setIsOpen(status);
  };
  const [listaDeMotivos, setListaDeMotivos] = useState<{
    listaMotivoDesbloqueio: any[];
  }>({ listaMotivoDesbloqueio: [] });
  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const [base64, setBase64] = useState(null);
  const [saldo, setSaldo] = useState(0);
  const fetchListaMotivos = () => {
    api
      .get(window.config.baseUrl + `/auditoria/bloqueio/listar-motivos`)
      .then((res) => {
        const listaMotivoDesbloqueio = res.data.filter(
          (motivo: Motivo) => motivo?.idTipoAcao === TipoAcao.Desbloqueio,
        );
        setListaDeMotivos({
          listaMotivoDesbloqueio,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClickConfirmModal = () => {
    setLoading(true);
    const usuarioLogado = JSON.parse(localStorage.getItem("user"));
    const requestBody: any[] = [];
    requestBody.push({
      login: usuarioLogado.login, // quem está fazendo a modificação
      idTipoAcao: TipoAcao.Desbloqueio, //Bloqueio ou Desbloqueio
      idTipoBloqueio: 1, // Conta, Valor ou MidiaAvulso
      valor: null,
      idMotivoAcao: 2,
      justificativa: justificativa, // texto de justificativa
      cpf: dataUser?.numeroDocumento, // CPF sem máscara
      idProduto: idProduto,
      nrLogicoMidia: null, // se idTipoBloqueio = MidiaAvulso
      idPenalizacaoCliente: null,
      imagemJustificativa: null,
      base64, // base64, se tiver
      //idPenalizacaoCliente?: number;
    });

    if (justificativa && motivo) {
      desbloqueioContaUsoIndevido(requestBody[0]).then((result) => {
        if (result.status < 400) {
          showPopOver("success", "Desbloqueio conta", "Conta desbloqueada");
          onChangeModalBloqueioIndevido();
          setLoading(false);

          setTimeout(() => {
            setIdProduto(0);
            setIdProduto(3);
            setPodeDesbloquarConta(false);
          }, 100);
        } else {
          showPopOver(
            "error",
            "Desbloqueio conta",
            "Erro ao desbloquear, informe ao administrador!",
          );
          onChangeModalBloqueioIndevido();
          setLoading(false);
        }
      });
    } else {
      showPopOver(
        "error",
        "Desbloqueio conta",
        "Preencha a justifiva ou motivo!",
      );
    }
  };

  useEffect(() => {
    fetchListaMotivos();
  }, []);
  enum TipoAcao {
    Bloqueio = 1,
    Desbloqueio = 2,
  }

  let cartao: any = [];
  type Endereco = {
    nrSeqEndereco: number;
    logradouro: string;
    complemento: string;
    bairro: string;
    cidade: string;
    uf: string;
    cep: string;
    numero: string;
    dataInativacao: string | null;
  };

  enum PeriodosConsulta {
    quinze_dias = "QUINZE_DIAS_ATRAS",
    trinta_dias = "TRINTA_DIAS_ATRAS",
    sessenta_dias = "SESSENTA_DIAS_ATRAS",
    noventa_dias = "NOVENTA_DIAS_ATRAS",
    um_mes = "UM_MES_ATRAS",
    tres_meses = "TRES_MESES_ATRAS",
    seis_meses = "SEIS_MESES_ATRAS",
  }

  const [periodoSelecionado, setPeriodoSelecionado] =
    useState<PeriodosConsulta>(PeriodosConsulta.um_mes);

  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  const handleOpenAlertErro = () => {
    setIsOpenErro(!isOpenErro);
  };

  const handleOpenAlertGreen = () => {
    setIsOpenGreen(!isOpenGreen);
  };

  const handleChangeMetodoPagamento = (event: { target: { value: any } }) => {
    setMetodoPagamento(event.target.value);
  };

  const [dateRangeApi, setDateRangeApi] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  const iconColor = useColorModeValue("brand.500", "white");
  const greenIcon = useColorModeValue("green.500", "white");
  const redIcon = useColorModeValue("red.500", "white");
  const bgIconHover = useColorModeValue(
    { bg: "gray.100" },
    { bg: "whiteAlpha.50" },
  );
  const bgIconFocus = useColorModeValue(
    { bg: "grey.100" },
    { bg: "whiteAlpha.100" },
  );
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const shadow = useColorModeValue(
    "18px 17px 40px 4px rgba(112, 144, 176, 0.1)",
    "unset",
  );
  const textColor = useColorModeValue("secondaryGray.900", "white");

  const handleSelect = (ranges: any) => {
    setSelectedDateRange(ranges.selection);
  };

  const existeLaudoCliente = async (id: any) => {
    if (IsEmpty(laudo)) {
      buscarLaudo(id)
        .then((laudo) => {
          const laudoResult = [laudo];
          if (Array.isArray(laudoResult)) {
            setLaudo(laudoResult);
            setAcompanhante(laudoResult[0]?.necessitaAcompanhante);
            if (laudoResult[0]?.deficienciaPermanente === false) {
              if (laudoResult[0]?.necessitaAcompanhante === true) {
                setLimite(laudoResult[0]?.qtFrequenciaTratamento * 2);
              } else {
                setLimite(laudoResult[0]?.qtFrequenciaTratamento);
              }
            }
          } else {
            setLaudo([]);
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar laudo:", error);
        });
    }

    if (limitePassagensEstudante === 0 && id) {
      consultarGratuidadeEstudante(id).then(function (result) {
        const registroMaisAtual = result?.reduce(
          (registroMaisRecente: any, registroAtual: any) => {
            const dataMaisRecente = new Date(registroMaisRecente.dataInclusao);
            const dataAtual = new Date(registroAtual.dataInclusao);

            return dataAtual > dataMaisRecente
              ? registroAtual
              : registroMaisRecente;
          },
          result[0],
        );
        if (typeof registroMaisAtual === "object" && registroMaisAtual?.id) {
          if (
            registroMaisAtual?.statusGratuidade?.id === 3 ||
            registroMaisAtual?.tipoGratuidade.id === 1
          ) {
            buscarRegrasPorGratuidade(registroMaisAtual?.id).then(
              function (result) {
                if (result && result.length > 0) {
                  setLimitePassagensEstudante(76);
                  result.forEach((item: any) => {
                    if (item?.tipoRegraGratuidade?.id === 13) {
                      if (item.valor.toString() === "false") {
                        setBiometria(false);
                      } else {
                        setBiometria(true);
                      }
                    }
                  });
                }
              },
            );
          }
        }
      });
    }
  };
  const statusIcon = (status: any) => {
    switch (status) {
      case 1: //estudante
        return <Icon as={MdPeopleAlt} color={textYelBg} w="20px" h="18px" />;
      case 4: //funcional
        return (
          <Icon as={MdOutlinePolicy} color={textVerdeBg} w="20px" h="18px" />
        );
      case 3: //PNE
        return (
          <Icon as={MdOutlineAccessible} color={textGrayBg} w="20px" h="18px" />
        );
      case 2: //SENIOR
        return (
          <Icon
            as={MdOutlinePersonAddAlt1}
            color={textRedBg}
            w="20px"
            h="18px"
          />
        );
      default:
        return <Icon as={MdUnpublished} color={textRedBg} w="20px" h="18px" />;
    }
  };

  const handleCheckDataSenior = async (dataSenior: any) => {
    if (!isEmpty(dataSenior)) {
      const seniorData = await pesquisarDataSenior(dataSenior);
      if (seniorData?.data?.isSenior === false) {
        setIsSenior(false);
        return false;
      } else {
        setIsSenior(true);
        return true;
      }
    } else {
      return false;
    }
  };

  const finalizarPedido = async (idProduto: any) => {
    const taxaEntregaBoo = verificarSePossuiTaxaDeEntrega(
      idProduto,
      isSenior,
      tipoPedidoCartao,
      onViewRatioEndereco,
    );

    const tipoPagamento = getTipoPagamento(
      idProduto,
      isSenior,
      tipoPedidoCartao,
      onViewRatioEndereco,
      boletimOcorrencia,
    );

    const body: { [key: string]: any } = {
      idCliente: dataUser.codigo,
      idTipoPerfilCliente: "USUARIO",
      valorPedido: boletimOcorrencia
        ? 0
        : statusSegundaVia
          ? parseFloat(valorSegundaVia + taxaEnvio)
          : parseFloat(
            statusSegundaVia === false && onViewRatioEndereco === "loja"
              ? "0,00"
              : valorPrimeiraVia + taxaEnvio,
          ),
      valorCalculadoPedido: boletimOcorrencia
        ? 0
        : statusSegundaVia
          ? parseFloat(valorSegundaVia + taxaEnvio)
          : parseFloat(
            statusSegundaVia === false && onViewRatioEndereco === "loja"
              ? "0,00"
              : valorPrimeiraVia + taxaEnvio,
          ),
      itensPedido: [
        {
          idCliente: dataUser.codigo,
          idTipoMidia: idProduto === 2 || idProduto === 6 ? 4 : 1,
          idTipoPerfilCliente: "USUARIO",
          idTipoItemPedido: statusSegundaVia ? 6 : 3,
          valorCredito: 0,
          valorProduto: boletimOcorrencia
            ? 0
            : statusSegundaVia
              ? parseFloat(valorSegundaVia + taxaEnvio)
              : parseFloat(
                idProduto === 3 &&
                  statusSegundaVia === false &&
                  onViewRatioEndereco === "loja"
                  ? "0,00"
                  : valorPrimeiraVia + taxaEnvio,
              ),
          idProduto: idProduto === 2 || idProduto === 6 ? 6 : idProduto,
          idAplicacao: idProduto === 3 ? 600 : 10,
          idEmissorMidia: 5,
        },
      ],
      nrSeqEndereco: nrSeqEndereco || enderecoTO[0]?.nrSeqEndereco,
      tipoPagamento,
      isento2Via: boletimOcorrencia,
      comTaxaEntrega: statusSegundaVia
        ? taxaEntregaBoo
        : idProduto === 3 &&
          statusSegundaVia === false &&
          onViewRatioEndereco === "loja"
          ? false
          : true,
    };
    setLoading(true);

    finalizarPedidoCartaoAtendimento(body).then(function (result: any) {
      if (result !== 400 && result !== 404 && result !== 500) {
        showPopOver(
          "success",
          "Pedido",
          "Pedido de cartão realizado com sucesso!",
        );
        atualizaPedido(true);
        setLoading(false);
        atualizaCartao(true);
        setStatusSegundaVia(false);
        setPedidoFeito(true);
        if (document.getElementById("fotoElementoUsuario"))
          if (document.getElementById("fotoElementoUsuario"))
            document.getElementById("fotoElementoUsuario").style.display =
              "block";
        if (document.getElementById("fotoElementoUsuario2"))
          if (document.getElementById("fotoElementoUsuario2"))
            document.getElementById("fotoElementoUsuario2").style.display =
              "block";

        setLoading(false);
      } else if (result === 400 || result === 404) {
        showPopOver("error", "Ops...", "Erro na geração do pedido! ");
        atualizaPedido(true);
        setPedidoFeito(true);
        setLoading(false);

        if (document.getElementById("fotoElementoUsuario"))
          if (document.getElementById("fotoElementoUsuario"))
            document.getElementById("fotoElementoUsuario").style.display =
              "block";
        if (document.getElementById("fotoElementoUsuario2"))
          if (document.getElementById("fotoElementoUsuario2"))
            document.getElementById("fotoElementoUsuario2").style.display =
              "block";
      } else if (result === 500) {
        showPopOver("error", "Ops...", "Erro no servidor! ");
        setLoading(false);
        if (document.getElementById("fotoElementoUsuario"))
          if (document.getElementById("fotoElementoUsuario"))
            document.getElementById("fotoElementoUsuario").style.display =
              "block";
        if (document.getElementById("fotoElementoUsuario2"))
          if (document.getElementById("fotoElementoUsuario2"))
            document.getElementById("fotoElementoUsuario2").style.display =
              "block";
      }
      setViewPassoUm(!viewPassoUm);
      setModalFinalizaCompra(!modalFinalizaCompra);

      if (document.getElementById("fotoElementoUsuario"))
        if (document.getElementById("fotoElementoUsuario"))
          document.getElementById("fotoElementoUsuario").style.display =
            "block";
      if (document.getElementById("fotoElementoUsuario2"))
        if (document.getElementById("fotoElementoUsuario2"))
          document.getElementById("fotoElementoUsuario2").style.display =
            "block";
    });
    setValorSegundaVia("");
  };

  const cancelarCartao = async () => {
    if (motivoSelect !== 0 && motivoSelect.toString() !== "") {
      const body: { [key: string]: any } = {
        numeroDocumento: dataUser.numeroDocumento,
        idMidia: midiasContaPrincipal[tabState]?.midias[0]?.id,
        idProduto: midiasContaPrincipal[tabState]?.midias[0]?.idProduto,
        idMotivoCancelamento: motivoSelect,
      };

      cancelamentoCartao(body).then(function (result) {
        setLoadingCancelamento(true);
        if (result === 400) {
          setTipoErroPedido(
            "Já existe uma solicitação de exclusão para este cartão!",
          );
          setIsOpenErro(!isOpenErro);
        } else if (result >= 400) {
          setTipoErroPedido(
            "Erro ao tentar cancelar cartão, tente mais tarde!",
          );
          setIsOpenErro(!isOpenErro);
        } else if (result < 400) {
          setMsgStatusOk("Cartão cancelado com sucesso!");
          setIsOpenGreen(!isOpenGreen);
          atualizaPedido(!atualizarCartao);
          atualizaCartao(true);
          setAtualizarCartao(!atualizarCartao);
        }
        onChangeModalCancelamento();
        setLoadingCancelamento(false);
      });
    } else {
      setTipoErroPedido("Escolha o motivo do cancelamento!");
      setIsOpenErro(!isOpenErro);
    }
  };

  const temCartaoConta = (conta: any) => {
    cartao = conta.midias.find(
      (item: any) =>
        item.idProduto === idProduto && item.descricaoTipoMidia === "CARTAO",
    );

    if (cartao !== undefined) {
      setMidias([cartao]);
      return true;
    } else {
      setMidias([]);
      setExistePedido(false);
      cartao = [];
      return false;
    }
  };

  const handleFileChange = (event: any) => {
    const file = event.target.files[0]; // Get the selected file

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const b64 = e.target.result;
        const rawBase64 = b64.toString().split(",")[1];
        setBase64(rawBase64);
      };
      reader.readAsDataURL(file); // Read the file as a Data URL (Base64 encoded)
    }
  };

  const associarCartao = async (cartao: any, dadoUsuario: any) => {
    if (cartao.length === 19) {
      setLoadingAssociar(true);

      const body = {
        numeroLogicoMidia: cartao.replace(/-/g, ""),
        idCliente: dadoUsuario.codigo,
      };

      associarCartaoApi(body).then(function (result: any) {
        if (result === 200) {
          showPopOver(
            "success",
            "Pedido",
            "Associação de cartão realizada com sucesso!",
          );
          atualizaPedido(true);
          setLoadingAssociar(false);
          setModalAssociarCartao(false);
        } else {
          showPopOver(
            "error",
            "Ops...",
            "Erro ao associar cartão! " +
            result?.response?.data?.errorMessages || "",
          );
          setLoadingAssociar(false);
          setModalAssociarCartao(false);
        }
      });
    } else {
      showPopOver(
        "error",
        "Ops...",
        "Preencha corretamento os dados de cartão!",
      );

      setLoadingAssociar(false);
      setModalAssociarCartao(false);
    }
  };

  const bloqueioCartao = () => {
    bloquearCartao(midiasContaPrincipal[tabState]?.midias[0]?.id).then(
      function (result) {
        if (result < 400) {
          showPopOver("success", "Cadastro", "Cartão bloqueado com sucesso!");
          setModalCancelamento(!modalCancelamento);
          atualizaPedido(!atualizarCartao);
          atualizaCartao(true);
          setAtualizarCartao(!atualizarCartao);
        } else {
          showPopOver("error", "Ops...", "Erro ao bloquear cartão!");
          setModalCancelamento(!modalCancelamento);
        }
      },
    );
  };

  const desbloqueioCartao = () => {
    desbloquearCartao(midiasContaPrincipal[tabState]?.midias[0]?.id).then(
      function (result) {
        if (result < 400) {
          showPopOver(
            "success",
            "Cadastro",
            "Cartão desbloqueado com sucesso!",
          );
          setModalCancelamento(!modalCancelamento);
          atualizaPedido(!atualizarCartao);
          atualizaCartao(true);
          setAtualizarCartao(!atualizarCartao);
        } else {
          showPopOver("error", "Ops...", "Erro ao desbloquear cartão!");
          setModalCancelamento(!modalCancelamento);
        }
      },
    );
  };

  const onModalMotivo = async () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "none";
    setBloqueioModal(false);
    setModalCancelamento(!modalCancelamento);
  };

  const onModalBloqueio = async () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "none";
    setBloqueioModal(true);
    setModalCancelamento(!modalCancelamento);
  };

  const handleChangeSelectCancelamentoMotivo = (event: {
    target: { value: any };
  }) => {
    setMotivoSelect(parseInt(event.target.value));
  };

  const handleChangeSelectLojaCasa = (event: { target: { value: any } }) => {
    setLojaSelect(parseInt(event.target.value));
    setTaxaEnvio("");
    setViewBotaoProsseguir(false);
    const retorno: any[] = [
      lojas.filter((item) => item.codigo === parseInt(event.target.value))[0],
    ];

    const maioresNrSeqEndereco: number[] = retorno.map((item) => {
      if (item?.enderecos && item?.enderecos.length > 0) {
        return item?.enderecos.reduce(
          (maxNrSeq: number, endereco: { nrSeqEndereco: number }) =>
            Math.max(maxNrSeq, endereco.nrSeqEndereco),
          item.enderecos[0].nrSeqEndereco,
        );
      }
    });

    const maioresCeps: string[] = retorno.map((item) => {
      if (item?.enderecos && item?.enderecos.length > 0) {
        return item?.enderecos.reduce(
          (maxCep: string, endereco: { cep: string }) =>
            maxCep.localeCompare(endereco.cep) >= 0 ? maxCep : endereco.cep,
          item.enderecos[0].cep,
        );
      }
    });
    setCepLoja(maioresCeps[0]);
    setTaxaEnvio("");
    setNrSeqEndereco(maioresNrSeqEndereco[0]);
  };

  const cancelarPedido = async (numeroPedido: any) => {
    const user = JSON.parse(localStorage.getItem("user"));
    bodyPedido.idContaAcessoCancelamento = user.jti;
    bodyPedido.numeroPedido = numeroPedido;
    bodyPedido.idMotivoCancelamentoPedido = 5;
    setLoading(true);
    await cancelarPedidoApi(bodyPedido).then(function (result) {
      if (result === 200) {
        showPopOver("success", "Pedido", "Pedido excluído com sucesso!");
        setExistePedido(false);
        setPedidoPrimeiraVia(false);
        setPedidoSegundaVia(false);
        setPedidoFeito(false);
        setPodeAssociarCartao(true);
        setTipoPedidoCartao("PODE SOLICITAR SEGUNDA_VIA");
        atualizaPedido(true);
        setLoading(false);
        setAtualizarCartao(true);
      } else {
        setTipoErroPedido("Erro ao excluir pedido!");
        setIsOpenErro(!isOpenErro);
        setLoading(false);
      }
    });

    setModalPedidoCancelamento(false);
  };

  const onChangeModalData = () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "none";
    setModalData(!modalData);
  };

  const onChangeModalDataClose = (openModal = true) => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    if (openModal) {
      setModalData(!modalData);
    }
  };

  const onChangeModalBloqueioIndevido = (openModal = true) => {
    setBase64(null);
    setMotivo(null);
    setJustificativa("");

    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "none";
    if (openModal) {
      setIsOpenModalBloqueioIndevido(!isOpenModalBloqueioIndevido);
    }
  };

  const onChangeModalPedidoCancelamento = (openModal = true) => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    if (openModal) {
      setModalPedidoCancelamento(!modalPedidoCancelamento);
    }
  };

  const onChangeModalCancelamento = async () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    setMotivoSelect(0);
    setModalCancelamento(!modalCancelamento);
  };

  const onChangeModalFinalizaCompra = async () => {
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalFinalizaCompra(false);
  };

  const onChangeModalUsoIndevido = async () => {
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalUsoIndevido(false);
  };

  const onChangeRadioEndereco = async (event: any) => {
    if (event === "casa") {
      buscaNrSeq();
      setViewBotaoProsseguir(false);
      setLojaSelect(0);
    } else if (event === "loja" && lojaSelect !== 0) {
      setViewBotaoProsseguir(false);
      setTaxaEnvio("");
    } else {
      setViewBotaoProsseguir(true);
      setTaxaEnvio("");
    }
    setViewRatioEndereco(event);
  };

  const onChange2Via = async () => {
    setStatusSegundaVia(true);
    onChangeModalPedidoCartao();
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "none";
  };

  const onChangeModalPedidoCartao = async () => {
    setLoading(true);
    setBoletimOcorrencia(false);

    if (dataUser) {
      if (document.getElementById("fotoElementoUsuario"))
        if (document.getElementById("fotoElementoUsuario"))
          document.getElementById("fotoElementoUsuario").style.display = "none";
      if (document.getElementById("fotoElementoUsuario2"))
        if (document.getElementById("fotoElementoUsuario2"))
          document.getElementById("fotoElementoUsuario2").style.display =
            "none";
    }
    //taxaEntrega();

    const fetchLojas = async () => {
      const res = await buscarLojasNaAPI();
      if (typeof res !== "undefined" && Array.isArray(res)) {
        localStorage.setItem("lojas", JSON.stringify(res));
        setLojas(obterEnderecosMaisRecentes(res));
        setLoading(false);
      } else if (res === 403) {
        setTimeout(() => {
          showPopOver("error", "Ops..", "Sessão expirada, logue novamente!");
        }, 3000);
        setLoading(false);
      } else {
        showPopOver(
          "error",
          "Lojas",
          "Erro ao buscar lojas, contate o administrador!",
        );
        setLoading(false);
      }
    };
    fetchLojas();

    setViewBotaoProsseguir(true);
    setViewRatioEndereco("loja");
    setViewPassoUm(true);
    setModalPedidoCartao(!modalPedidoCartao);
    setComplemento(dataUser.enderecos[0]?.complemento);
    setBairro(dataUser.enderecos[0]?.bairro);
    setCep(dataUser.enderecos[0]?.cep);
    // if (IsEmpty(dataUser.enderecos[0]?.cep)){
    //   setCep("");
    //   //chamar api para verificar se o cep entrega cartão

    // }
    setUf(dataUser.enderecos[0]?.uf);
    setCidade(dataUser.enderecos[0]?.cidade);
    setNumero(dataUser.enderecos[0]?.numero);
    setLogradouro(dataUser.enderecos[0]?.logradouro);
  };
  function obterEnderecoMaisRecente(enderecos: Endereco[]): Endereco {
    if (enderecos?.length !== 0) {
      return enderecos.reduce((prev, curr) =>
        prev?.nrSeqEndereco > curr?.nrSeqEndereco ? prev : curr,
      );
    } else {
      return null;
    }
  }
  function obterEnderecosMaisRecentes(lojas: any) {
    return lojas.map((loja: any) => {
      const enderecoMaisRecente = obterEnderecoMaisRecente(loja.enderecos);
      return {
        ...loja,
        enderecos: [enderecoMaisRecente],
      };
    });
  }

  const onCloseModalPedidoCartao = () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    setLojaSelect(0);
    setViewRatioEndereco("loja");
    setViewPassoUm(true);
    if (viewBotaoProsseguir === false) {
      setViewBotaoProsseguir(true);
    }
    setModalPedidoCartao(!modalPedidoCartao);
  };

  const onCloseModalAssociarCartao = () => {
    setLoadingAssociar(false);
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalAssociarCartao(!modalAssociarCartao);
  };
  const onPesquisar = async (dateRange: any, openModal = true) => {
    setLoadingDataTransacoes(true);
    onChangeModalDataClose(false);
    setHistoricoExtrato([]);
    setBuscaSete(false);
    if (window.config.tenant !== "macae") {
      await midiaPesquisar(dataUser, dateRange, false, idProduto);
    } else {
      ExtratoMacae(null, dateRange, dataUser.codigo);
    }

    setLoadingDataTransacoes(false);
    setDateRangeApi(dateRange);
    if (openModal) {
      setShowFixedDate(false);
      setModalData(!modalData);
    } else {
      setShowFixedDate(true);
    }
  };

  const onProsseguir = (idProduto: any) => {
    setModalFinalizaCompra(!modalFinalizaCompra);
    setModalPedidoCartao(false);
    taxaEntrega();
    if (statusSegundaVia) {
      valor2Via(idProduto).then(function (result) {
        if (result) {
          const stringifyResponse2Via = JSON.stringify(result);
          const parsedResponse2Via = JSON.parse(stringifyResponse2Via);
          setValorSegundaVia(parsedResponse2Via?.valor);
        }
      });
      buscarTaxaEntrega(cepLoja).then(function (resultCep) {
        if (resultCep) {
          setTaxaEnvio("0");
        }
      });
    } else {
      setValorSegundaVia("0");
      setTaxaEnvio("0");
    }
  };

  const onVoltarPrimeiraRecarga = () => {
    setViewRatioEndereco("loja");
    setModalFinalizaCompra(false);
    setViewBotaoProsseguir(false);
    setCepLoja("");
    setEnderecoTO([]);
    setCep("");
    setModalPedidoCartao(true);
    setViewPassoUm(true);
    setLojaSelect(0);
  };

  const midiaPesquisar = async (
    dadosUsuario: any,
    range: any,
    buscaSete: any,
    idProdutoMidiaPesquisar: any,
  ) => {
    if (!IsEmpty(dadosUsuario)) {
      setHistoricoExtrato([]);
      const historicoApi = await buscarHistoricoExtrato(
        dadosUsuario.codigo,
        range,
        buscaSete,
        idProdutoMidiaPesquisar,
      );

      let valorPositivo = 0;
      let valorNegativo = 0;

      if (!IsEmpty(historicoApi)) {
        historicoApi.forEach((extrato: any) => {
          if (extrato.tipoUtilizacao === 2) {
            valorPositivo += extrato.valorLancamento;
          }
          if (extrato.tipoUtilizacao === 1) {
            valorNegativo += extrato.valorLancamento;
          }
        });

        const total = valorPositivo + Math.trunc(valorNegativo * 100) / 100;
        setSomaPesquisaUtilizacao(total);
        const historicoOrdenadoPorDataProcessamento = [...historicoApi].sort(
          (a, b) =>
            new Date(b.dataProcessamento).getTime() -
            new Date(a.dataProcessamento).getTime(),
        );
        setHistoricoExtrato(historicoOrdenadoPorDataProcessamento);
      }
    }
  };

  const pesquisaUtilizacao = async () => {
    setHistoricoExtrato([]);
    const historicoApi = await buscarHistoricoExtrato(
      dataUser.codigo,
      dateRangeApi,
      buscaSete,
      idProduto,
    );
    let valorNegativo = 0;
    const historicoExtratoNegativo: any[] = [];
    historicoApi.forEach((extrato: any) => {
      if (extrato.tipoUtilizacao === 1) {
        historicoExtratoNegativo.push(extrato);
        valorNegativo += extrato.valorLancamento;
      }
    });
    setSomaPesquisaUtilizacao(Number(valorNegativo.toFixed(2)));
    const historicoNegativoOrdenadoPorDataProcessamento = [
      ...historicoExtratoNegativo,
    ].sort(
      (a, b) =>
        new Date(b.dataProcessamento).getTime() -
        new Date(a.dataProcessamento).getTime(),
    );
    setHistoricoExtrato(historicoNegativoOrdenadoPorDataProcessamento);
  };

  useEffect(() => {
    const fetchSeniorStatus = async () => {
      const senior = await handleCheckDataSenior(dataUser?.dataNascimento);
      setIsSenior(senior);
    };
    fetchSeniorStatus();
  }, []);

  useEffect(() => {
    const fetchSeniorStatus = async () => {
      const senior = await handleCheckDataSenior(dataUser?.dataNascimento);
      setIsSenior(senior);
    };
    fetchSeniorStatus();
  }, []);

  const taxaEntrega = async () => {
    const possuiTaxaDeEntrega = verificarSePossuiTaxaDeEntrega(
      idProduto,
      isSenior,
      tipoPedidoCartao,
      onViewRatioEndereco,
    );

    if (cep || cepUserNovo || enderecoTO[0]?.cep) {
      setLoading(true);
      const taxaEnvioApi = await buscarTaxaEntrega(
        maskOnlyNumbers(cepUserNovo || cep || enderecoTO[0]?.cep),
      );
      setLoading(false);

      if (!possuiTaxaDeEntrega) {
        setTaxaEnvio("0");
      } else {
        setTaxaEnvio(taxaEnvioApi?.valorTaxa);
      }
    } else {
      setViewBotaoProsseguir(false);
    }
  };

  const onPesquisarTodos = async (dateRange: any) => {
    setHistoricoExtrato([]);
    setSomaPesquisaUtilizacao(0.0);
    const historicoApi = await buscarHistoricoExtrato(
      dataUser.codigo,
      dateRange,
      buscaSete,
      idProduto,
    );
    let valorPositivo = 0;
    let valorNegativo = 0;

    historicoApi.forEach((extrato: any) => {
      if (extrato.tipoUtilizacao === 2) {
        valorPositivo += extrato.valorLancamento;
      }
      if (extrato.tipoUtilizacao === 1) {
        valorNegativo += extrato.valorLancamento;
      }
    });

    const total = valorPositivo + Math.trunc(valorNegativo * 100) / 100;
    setSomaPesquisaUtilizacao(total);
    const historicoOrdenadoPorDataProcessamento = [...historicoApi].sort(
      (a, b) =>
        new Date(b.dataProcessamento).getTime() -
        new Date(a.dataProcessamento).getTime(),
    );
    setHistoricoExtrato(historicoOrdenadoPorDataProcessamento);
  };

  const pesquisaCredito = async () => {
    setHistoricoExtrato([]);
    const historicoApi = await buscarHistoricoExtrato(
      dataUser.codigo,
      dateRangeApi,
      buscaSete,
      idProduto,
    );

    let valorPositivo = 0;
    const historicoExtratoCredito = historicoApi.filter((extrato: any) => {
      if (extrato.tipoUtilizacao === 2) {
        valorPositivo += extrato.valorLancamento;
        return true;
      }
      return false;
    });

    setSomaPesquisaUtilizacao(Math.trunc(valorPositivo * 100) / 100);
    const historicoOrdenadoPorDataProcessamento = [
      ...historicoExtratoCredito,
    ].sort(
      (a, b) =>
        new Date(b.dataProcessamento).getTime() -
        new Date(a.dataProcessamento).getTime(),
    );
    setHistoricoExtrato(historicoOrdenadoPorDataProcessamento);
  };
  const descricaoCor = (descricao: any, status: any) => {
    switch (status) {
      case "Aprovado":
        return (
          <Text color={"gray.100"} fontSize="sm" fontWeight="700">
            {"Possui " + descricao}
          </Text>
        );

      case "Solicitado":
        return (
          <Text color={"gray.100"} fontSize="sm" fontWeight="700">
            {"Solicitada a " + descricao}
          </Text>
        );

      case "Cancelado":
        return (
          <Text color={"gray.100"} fontSize="sm" fontWeight="700">
            {"Possui " + descricao + " cancelada"}
          </Text>
        );

      case "Rejeitado":
        return (
          <Text color={"gray.100"} fontSize="sm" fontWeight="700">
            {"Possui " + descricao + " rejeitada"}
          </Text>
        );

      case "Bloqueado":
        return (
          <Text color={"gray.100"} fontSize="sm" fontWeight="700">
            {"Possui " + descricao + " bloqueada"}
          </Text>
        );
      case "Suspeita de fraude":
        return (
          <Text color={"gray.100"} fontSize="sm" fontWeight="700">
            {"Possui " + descricao} {" - Bloqueado por uso indevido"}
          </Text>
        );
      case "Desbloqueado":
        return (
          <Text color={"gray.100"} fontSize="sm" fontWeight="700">
            {"Sem  " + descricao}
          </Text>
        );

      default:
        return (
          <Text color={"gray.100"} fontSize="sm" fontWeight="700">
            {"Possui " + descricao} {fraude && " - Bloqueado por uso indevido"}
          </Text>
        );
    }
  };

  const buscaNrSeq = async () => {
    try {
      // Pesquisa cliente
      dataLoginEndereco = await pesquisaCliente({
        email: null,
        nome: null,
        numeroDocumento: dataUser?.numeroDocumento,
        tipoBusca: "TODOS",
        tipoPessoa: "F",
      });
      if (dataLoginEndereco.length > 0) {
        setEnderecoTO([dataLoginEndereco[0].enderecos[0]]);
      }
    } catch (error) {
      console.error("Erro ao buscar número sequencial:", error);
    }
  };

  useEffect(() => {
    buscaNrSeq();
  }, [enderecoAtualizar]);

  useEffect(() => {
    setLoading(true);
    if (!IsEmpty(dataUser) && midiasContaPrincipal && idProduto !== 0) {
      buscar2Via(midiasContaPrincipal[tabState]?.idProduto).then(
        async function (resultTaxa: any) {
          if (resultTaxa !== 400 || resultTaxa !== 500) {
            setValorPrimeiraVia("0");
            setValorSegundaVia(resultTaxa[0]?.valor2Via);
          }
        },
      );
      codigoProdutoParaPedido(midiasContaPrincipal[tabState].idProduto);
      const idsMidiaTipo1 = midiasContaPrincipal[tabState].midias
        .filter((m: any) => m.idTipoMidia === 1 || m.idTipoMidia === 4)
        .map((m: any) => m.id);

      pesquisaHistoricoMidia(idsMidiaTipo1 || null);
      buscarHistoricoPedidoCartao(
        dataUser.codigo,
        midiasContaPrincipal[tabState].idProduto === 2
          ? "6"
          : midiasContaPrincipal[tabState].idProduto,
      ).then(function (result: any) {
        if (result !== 400 || result !== 500) {
          if (result?.idPedido !== 0) {
            setNumeroPedido(result?.idPedido);
          }
          if (result?.tipoPedido === "1 VIA SOLICITADA") {
            setPedidoPrimeiraVia(true);
            setTipoPedidoCartao(result?.tipoPedido);
            setPedidoSegundaVia(false);
            setExistePedido(true);
          } else if (result?.tipoPedido === "2 VIA SOLICITADA") {
            setPedidoSegundaVia(true);
            setTipoPedidoCartao(result?.tipoPedido);
            setPedidoPrimeiraVia(false);
            setExistePedido(true);
          } else if (result?.tipoPedido === "PODE SOLICITAR PRIMEIRA_VIA") {
            setExistePedido(false);
            setTipoPedidoCartao(result?.tipoPedido);
            setStatusSegundaVia(false);
          } else if (result?.tipoPedido === "PODE SOLICITAR SEGUNDA_VIA") {
            setExistePedido(false);
            setTipoPedidoCartao(result?.tipoPedido);
            setStatusSegundaVia(true);
          } else if (result.tipoPedido === "EXISTE") {
            setExistePedido(true);
          }
          setLoading(false);
        }
      });
    }
  }, [
    tabState,
    dataUser,
    solicitarCartao,
    pedidoFeito,
    existePedido,
    midiasContaPrincipal,
    idProduto,
  ]);

  useEffect(() => {
    if (laudo.length === 0) {
      existeLaudoCliente(dataUser?.codigo);
    }
  }, [dataUser]);

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("stayLogged");
    setLoading(false);
    window.location.href = "/atendimento#/auth/sign-in";
    window.location.reload();
    //}, 3000);
  };
  useEffect(() => {
    if (localStorage.getItem("motivosCancelamento") === null) {
      getListaMotivosCancelamento().then(function (result: any) {
        if (result !== 400 && result !== 500 && result !== 404) {
          setMotivos(result);
          localStorage.setItem("motivosCancelamento", JSON.stringify(result));
        }
        if (result !== 403) {
          logout();
        } else {
          setMotivos([]);
        }
      });
    } else {
      const storedMotivosStr = localStorage.getItem("motivosCancelamento");

      if (!storedMotivosStr) {
        setMotivos([]);
        showPopOver("error", "Ops...", "Erro ao buscar motivos cancelamento!");
      } else {
        try {
          const storedMotivos: any[] = JSON.parse(storedMotivosStr);

          const filtrados = storedMotivos.filter((item: any) => item.id !== 8);
          setMotivos(filtrados);
        } catch (e) {
          setMotivos([]);
          showPopOver(
            "error",
            "Ops...",
            "Erro ao processar motivos cancelamento!",
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    setSomaPesquisaUtilizacao(0);
    const fetchData = async () => {
      if (buscaSete === true) {
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1);
        const endtDate = new Date();
        endtDate.setDate(endtDate.getDate() + 1);

        dateRangeApi.startDate = maskDataContaVirtual(startDate);
        dateRangeApi.endDate = maskDataContaVirtual(endtDate);
        midiaPesquisar(dataUser, dateRangeApi, true, idProduto);
      } else {
        midiaPesquisar(dataUser, dateRangeApi, false, idProduto);
      }
      if (!IsEmpty(midiasContaPrincipal)) {
        if (
          midiasContaPrincipal[tabState]?.descricaoStatusMidia === "CANCELADA"
        ) {
          setCartaoCancelado("CANCELADA");
        } else {
          setCartaoCancelado(
            midiasContaPrincipal[tabState]?.descricaoStatusMidia,
          );
        }
      } else {
        setHistoricoExtrato([]);
      }
    };
    if (
      !IsEmpty(dataUser) &&
      modalCancelamento === false &&
      midiasContaPrincipal &&
      idProduto !== 0
    ) {
      fetchData();
    }
  }, [dataUser, idProduto]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setHistoricoGratuidade([]);
      let totalGratuidadesValidas = 0;
      let estudanteBloqueado = false;
      let pcdBloqueado = false;
      let seniorBloqueado = false;
      consultarPenalizacaoGratuidade(dataUser.codigo, 3).then(
        (resultPenalizacao: any) => {
          if (
            resultPenalizacao &&
            resultPenalizacao.length > 0 &&
            resultPenalizacao !== 500 &&
            resultPenalizacao !== 400 &&
            resultPenalizacao !== 404
          ) {
            setPenalizacaoGratuidade(resultPenalizacao);
            const agora = new Date();

            const existeBloqueioVigente = resultPenalizacao.some(
              (item: any) => {
                const dataFim = new Date(item.dataFimBloqueio);
                return dataFim > agora; // ainda vigente
              },
            );
            //todo voltar quando for liberado
            // if (existeBloqueioVigente) {
            //   setFraude(true);
            //   setContaBloqueada(true);
            // }

            // if (!existeBloqueioVigente) {
            //   setPodeDesbloquarConta(true);
            // }
            setLoading(false);
          } else {
            setPenalizacaoGratuidade([]);
            setLoading(false);
          }
        },
      );

      if (
        IsEmpty(historicoGratuidadeEstudanteCartao) &&
        IsEmpty(historicoGratuidadePcdCartao) &&
        IsEmpty(historicoGratuidadeSeniorCartao)
      ) {
        setTemHistorico(false);
      } else {
        if (
          historicoGratuidadeEstudanteCartao !== "Gratuidade não existe!" &&
          historicoGratuidadeEstudanteCartao !== 500 &&
          historicoGratuidadeEstudanteCartao.length > 0
        ) {
          totalGratuidadesValidas++;
          historicoGratuidadeEstudanteCartao.map((estudante: any) => {
            if (
              estudante.statusGratuidade?.id === 8 ||
              estudante.statusGratuidade?.id === 6 ||
              estudante.statusGratuidade?.id === 4
            ) {
              //setUsoIndevido(true);
              //setModalUsoIndevido(true);
              estudanteBloqueado = true;
              setContaBloqueadaEstudante(true);
              //setFraude(true);
            }

            return estudante;
          });

          setTemHistorico(true);
          const historicoMaisRecenteEstudante =
            historicoGratuidadeEstudanteCartao.reduce(
              (maisRecente: any, atual: any) => {
                // Verifica se o objeto atual possui uma dataInclusao e se é mais recente que o objeto maisRecente
                if (
                  atual.dataInclusao &&
                  (!maisRecente ||
                    atual.dataInclusao > maisRecente.dataInclusao)
                ) {
                  return atual; // Se for mais recente, atualiza o objeto maisRecente
                }
                return maisRecente; // Caso contrário, mantém o objeto maisRecente inalterado
              },
              null,
            );

          const regrasTipo4 = historicoMaisRecenteEstudante?.regraGratuidadeList
            ?.filter((r: any) => r.tipoRegraGratuidade?.id === 4)
            ?.sort((a: any, b: any) => b.id - a.id)?.[0];

          setDataFimValidadeRegraEstudante(
            regrasTipo4?.dataFimValidade || null,
          );

          setHistoricoGratuidade((prevState) => [
            ...prevState,
            historicoGratuidadeEstudanteCartao
              ? {
                statusGratuidade:
                  historicoMaisRecenteEstudante?.statusGratuidade?.descricao,
                descricaoGratuidade: "gratuidade Estudante",
                idGratuidade:
                  historicoMaisRecenteEstudante?.tipoGratuidade?.id,
                descricaoStatusGratuidade:
                  historicoMaisRecenteEstudante
                    ?.historicoStatusGratuidadeList[0]?.statusGratuidade
                    ?.descricao || "",
              }
              : {
                descricaoGratuidade: "gratuidade Estudante",
                statusGratuidade: null,
              },
          ]);
        }

        if (
          historicoGratuidadePcdCartao !== "Gratuidade não existe!" &&
          historicoGratuidadePcdCartao !== 500 &&
          historicoGratuidadePcdCartao.length > 0
        ) {
          totalGratuidadesValidas++;
          historicoGratuidadePcdCartao.map((pcd: any) => {
            if (
              pcd.statusGratuidade?.id === 8 ||
              pcd.statusGratuidade?.id === 6 ||
              pcd.statusGratuidade?.id === 4
            ) {
              //setUsoIndevido(true);
              //setModalUsoIndevido(true);
              //setFraude(true);
              pcdBloqueado = true;
              setContaBloqueadaPcd(true);
            }
            //return pcd;
          });

          setTemHistorico(true);
          const historicoMaisRecentePcd = historicoGratuidadePcdCartao.reduce(
            (maisRecente: any, atual: any) => {
              if (
                atual.dataInclusao &&
                (!maisRecente || atual.dataInclusao > maisRecente.dataInclusao)
              ) {
                return atual;
              }
              return maisRecente;
            },
            null,
          );

          const regraQuantidadeMensalAtiva =
            historicoMaisRecentePcd?.regraGratuidadeList.sort(
              (a: any, b: any) => {
                return (
                  new Date(a.dataFimValidade).getTime() -
                  new Date(b.dataFimValidade).getTime()
                );
              },
            )[0];

          const regrasTipo1 =
            historicoMaisRecentePcd?.regraGratuidadeList.filter(
              (r: any) => r.tipoRegraGratuidade?.id === 1,
            );

          const regraComId1Maior = regrasTipo1?.length
            ? regrasTipo1.reduce((maior: any, atual: any) =>
              atual.id > maior.id ? atual : maior,
            )
            : null;

          const regrasTipo4 = historicoMaisRecentePcd?.regraGratuidadeList
            ?.filter((r: any) => r.tipoRegraGratuidade?.id === 4)
            ?.sort((a: any, b: any) => b.id - a.id)?.[0];

          if (regraComId1Maior?.tipoRegraGratuidade?.nome == "Ilimitado") {
            setIsIlimitado(true);
          }
          const valor = regraQuantidadeMensalAtiva?.valor || 0;

          const regraMaisRecente = historicoMaisRecentePcd?.regraGratuidadeList
            ?.filter((r: any) => r.tipoRegraGratuidade?.id === 12)
            .sort(
              (a: any, b: any) =>
                new Date(b.dataInicioValidade || b.dataInclusao).getTime() -
                new Date(a.dataInicioValidade || a.dataInclusao).getTime(),
            )[0];

          setAcompanhante(regraMaisRecente?.valor || false);
          setValorAtualAcompanhantePCD(regraMaisRecente?.valor || false);

          if (
            regraComId1Maior?.dataFimValidade !== undefined ||
            regrasTipo4?.dataFimValidade !== undefined
          ) {
            setDataFimValidadeRegraPcd(
              regraComId1Maior?.dataFimValidade ||
              regrasTipo4?.dataFimValidade ||
              null,
            );
          }

          setHistoricoGratuidade((prevState) => [
            ...prevState,
            historicoMaisRecentePcd
              ? {
                statusGratuidade:
                  historicoMaisRecentePcd?.statusGratuidade?.descricao,
                descricaoGratuidade: "gratuidade PCD",
                idGratuidade: historicoMaisRecentePcd?.tipoGratuidade?.id,
                descricaoStatusGratuidade:
                  historicoMaisRecentePcd?.statusGratuidade?.descricao || "",
                valorMensal: valor,
              }
              : {
                descricaoGratuidade: "gratuidade PCD",
                statusGratuidade: null,
                valorMensal: valor,
              },
          ]);
        }

        if (
          historicoGratuidadeSeniorCartao !== "Gratuidade não existe!" &&
          historicoGratuidadeSeniorCartao !== 500 &&
          historicoGratuidadeSeniorCartao.length > 0
        ) {
          totalGratuidadesValidas++;
          historicoGratuidadeSeniorCartao.map((senior: any) => {
            if (
              senior.statusGratuidade?.id === 8 ||
              senior.statusGratuidade?.id === 6 ||
              senior.statusGratuidade?.id === 4
            ) {
              //setUsoIndevido(true);
              //setFraude(true);
              //setModalUsoIndevido(true);
              seniorBloqueado = true;
              setContaBloqueadaSenior(true);
            }
            return senior;
          });
          setTemHistorico(true);
          const historicoMaisRecenteSenior =
            historicoGratuidadeSeniorCartao.reduce(
              (maisRecente: any, atual: any) => {
                // Verifica se o objeto atual possui uma dataInclusao e se é mais recente que o objeto maisRecente
                if (
                  atual.dataInclusao &&
                  (!maisRecente ||
                    atual.dataInclusao > maisRecente.dataInclusao)
                ) {
                  return atual; // Se for mais recente, atualiza o objeto maisRecente
                }
                return maisRecente; // Caso contrário, mantém o objeto maisRecente inalterado
              },
              null,
            );
          setHistoricoGratuidade((prevState) => [
            ...prevState,
            historicoGratuidadeSeniorCartao
              ? {
                statusGratuidade:
                  historicoMaisRecenteSenior?.statusGratuidade?.descricao,
                descricaoGratuidade: "gratuidade Sênior",
                idGratuidade: historicoMaisRecenteSenior?.tipoGratuidade?.id,
                descricaoStatusGratuidade:
                  historicoMaisRecenteSenior?.historicoStatusGratuidadeList[0]
                    ?.descricao || "",
              }
              : {
                descricaoGratuidade: "gratuidade Sênior",
                statusGratuidade: null,
              },
          ]);
        }

        const totalBloqueios = [
          estudanteBloqueado,
          pcdBloqueado,
          seniorBloqueado,
        ].filter(Boolean).length;
        if (totalGratuidadesValidas == totalBloqueios) {
          setContaBloqueada(true);
        }
      }
    };

    if (
      (!isEmpty(dataUser) &&
        isEmpty(historicoGratuidade) &&
        temHistorico === false) ||
      idProduto === 3
    )
      if (historicoGratuidade.length === 0 || idProduto === 3) fetchData();

    if (!IsEmpty(midiasContaPrincipal)) {
      midiasContaPrincipal !== null &&
        midiasContaPrincipal.find(
          (conta: any, x: any) => temCartaoConta(conta) === true,
        );
    }
  }, [dataUser, enderecoAtualizar, tabState, idProduto]);

  // useEffect(() => {
  //   if (!IsEmpty(midiasContaPrincipal)) {
  //     midiasContaPrincipal !== null &&
  //       midiasContaPrincipal.find(
  //         (conta: any, x: any) => temCartaoConta(conta) === true
  //       );
  //   }
  // }, [idProduto]);

  useEffect(() => {
    api.get('/mobilidade/operadora').then(res => setListaOperadoras(res.data));
  }, []);

  useEffect(() => {
    api.get('/midia/modelos').then(res => setListaMidias(res.data));
  }, []);

  useEffect(() => {
    api.get('/mobilidade/modal/modais')
      .then(response => {
        setListaModais(response.data);
      })
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const result = await getBloqueioContas(dataUser?.numeroDocumento);
        if ([500, 400, 404].includes(result)) {
          setContaBloqueada(false);
          return;
        }

        const itemDoProduto =
          result?.filter((item: any) => item.idProduto === idProduto) ?? [];
        const firstItem = itemDoProduto[0];
        if (firstItem?.idProduto === idProduto) {
          if (firstItem?.podeDesbloquear === true) {
            setPodeDesbloquarConta(true);
          } else if (
            firstItem?.podeDesbloquear === false &&
            firstItem?.idTipoBloqueio === 1 &&
            firstItem?.idTipoAcao === 1
          ) {
            setPodeDesbloquarConta(false);
            setFraude(true);
            setContaBloqueada(true);
          }
          //  else {
          //   switch (idProduto) {
          //     case 1:
          //       setContaBloqueadaEstudante(true);
          //       break;
          //     case 2:
          //       setContaBloqueadaSenior(true);
          //       break;
          //     case 3:
          //       setContaBloqueadaPcd(true);
          //       break;
          //   }

          //   //setFraude(true);
          // }
        }

        // // regra 1: tem ação 1?
        // const itemAcao1 = itemDoProduto.find(
        //   (item: any) => item.idTipoAcao === 1
        // );

        // if (itemAcao1 === true) {
        //   setContaBloqueada(true);
        // }

        // regra 2: ação 1 + tipo bloqueio 2
        const valorBloqueio = itemDoProduto.find(
          (item: any) => item.idTipoAcao === 1 && item.idTipoBloqueio === 2,
        );

        if (valorBloqueio) {
          setValorBloqueadoContaIndevida(valorBloqueio.valor ?? 0);
        }
        setLoading(false);
      } catch (e) {
        console.error("Erro ao carregar bloqueio:", e);
        setContaBloqueada(false);
      }
    };
    load();
  }, [idProduto, tabState]);

  useEffect(() => {
    if (tabState === 0 && idProduto === 0 && midiasContaPrincipal) {
      setIdProduto(midiasContaPrincipal[0].idProduto);
      const element = document.getElementById("tabs-66--tab-0");

      if (element) {
        element.click();
      }
    }
  }, []);

  useEffect(() => {
    const fetchData = () => {
      ExtratoMacae(1, dateRangeApi, dataUser.codigo);
    };

    if (isEmpty(historicoExtratoMacae) && window.config.tenant === "macae") {
      fetchData();
    }
  }, [periodoSelecionado]);

  function ExtratoMacae(
    periodo: any,
    dateRange: dateRangeType,
    idBeneficiario: any,
  ) {
    setLoading(true);
    setLoadingDataTransacoes(true);
    setHistoricoExtratoMacae([]);
    buscarHistoricoExtratoMacae(periodo, dateRange, idBeneficiario).then(
      function (result: any) {
        if (result !== 500 && result !== 400 && result !== 404) {
          const ordenado = result.sort(
            (a: any, b: any) =>
              new Date(b.dataCompra).getTime() -
              new Date(a.dataCompra).getTime(),
          );

          setHistoricoExtratoMacae(ordenado);
        } else {
          setHistoricoExtratoMacae([]);
        }
        setLoading(false);
        setLoadingDataTransacoes(false);
      },
    );
  }

  function getLabelConsultaSelecionada() {
    switch (periodoSelecionado) {
      case PeriodosConsulta.quinze_dias:
        return "Últimos 15 dias";
        break;
      case PeriodosConsulta.trinta_dias:
        return "Últimos 30 dias";
        break;
      case PeriodosConsulta.sessenta_dias:
        return "Últimos 60 dias";
        break;
      case PeriodosConsulta.noventa_dias:
        return "Últimos 90 dias";
        break;
      case PeriodosConsulta.um_mes:
        return "Último mês";
        break;
      case PeriodosConsulta.tres_meses:
        return "Últimos três meses";
        break;
      case PeriodosConsulta.seis_meses:
        return "Últimos seis meses";
        break;
      default:
        return "";
        break;
    }
  }
  // useEffect(() => {
  //   const fetchLinhas = async () => {
  //     try {
  //       const response = await getLinhas();
  //       if (response.length > 0) {
  //         setLinhasList(response);
  //         localStorage.setItem("linhas", JSON.stringify(response));
  //       }
  //     } catch (error) {
  //       console.error("Erro ao buscar linhas:", error);
  //     }
  //   };

  //   if (linhasList.length === 0 && window.config.tenant !== "macae") {
  //     fetchLinhas();
  //   }
  // });
  function clickRangeButton(periodo: PeriodosConsulta) {
    setPeriodoSelecionado(periodo);
    const startDate = new Date();
    switch (periodo) {
      case PeriodosConsulta.quinze_dias:
        startDate.setDate(startDate.getDate() - 15);
        break;
      case PeriodosConsulta.trinta_dias:
        startDate.setDate(startDate.getDate() - 30);
        break;
      case PeriodosConsulta.sessenta_dias:
        startDate.setDate(startDate.getDate() - 60);
        break;
      case PeriodosConsulta.noventa_dias:
        startDate.setDate(startDate.getDate() - 90);
        break;
      case PeriodosConsulta.um_mes:
        startDate.setMonth(startDate.getMonth() - 1);
        break;
      case PeriodosConsulta.tres_meses:
        startDate.setMonth(startDate.getMonth() - 3);
        break;
      case PeriodosConsulta.seis_meses:
        startDate.setMonth(startDate.getMonth() - 6);
        break;
      default:
        return maskDataContaVirtual(startDate);
        break;
    }

    setDateRangeApi({
      startDate: startDate,
      endDate: new Date(),
      key: "selection",
    });

    onPesquisar(
      {
        startDate: maskDataContaVirtual(startDate),
        endDate: maskDataContaVirtual(new Date()),
        key: "selection",
      },
      false,
    );
  }

  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />
      <Card
        mb="20px"
        width={{ base: "100%", xl: "40vw" }}
        maxH={historicoExtrato.length > 3 ? "2036px" : "1346px"}
      >
        <Tabs>
          <TabList
            mb="20px"
            justifyContent={"center"}
            mx={{ base: "10px", lg: "20px" }}
            overflowX={{ sm: "unset", lg: "unset" }}
            border="0px solid transparent"
          >
            {/* <Flex justify="center" w="100%"> */}
            {midiasContaPrincipal !== null
              ? midiasContaPrincipal.map((conta: any, x: any) => (
                <Tab
                  key={x}
                  ref={(el) => (tabButtonRef.current[x] = el)}
                  p="0px"
                  flexDirection="column"
                  onMouseDown={() =>
                    window.config.tenant !== "macae" && setLoading(true)
                  }
                  onClick={function () {
                    if (window.config.tenant !== "macae") {
                      setLoading(true);
                    }
                    setDateRangeApi({
                      startDate: null,
                      endDate: null,
                      key: "selection",
                    });
                    setContaBloqueada(false);
                    setContaBloqueadaEstudante(false);
                    setContaBloqueadaPcd(false);
                    setContaBloqueadaSenior(false);
                    setValorBloqueado(false);
                    // setValorBloqueadoConta(0);
                    setValorBloqueadoContaIndevida(0);
                    setHistoricoExtrato([]);
                    setSomaPesquisaUtilizacao(0);
                    setPedidoPrimeiraVia(false);
                    setPedidoSegundaVia(false);
                    setTipoPedidoCartao("");
                    setValorPrimeiraVia("");
                    setValorSegundaVia("");
                    codigoProdutoParaPedido(conta?.idProduto);
                    setBuscaSete(true);
                    setPedidoFeito(false);
                    setTabState(x);
                    setIdProduto(conta?.idProduto);
                    temCartaoConta(conta);
                    setPenalizacaoGratuidade([]);
                    setFraude(false);
                    setUsoIndevido(false);
                    setHistoricoExtrato([]);
                    setHistoricoGratuidade([]);

                    // onPesquisar(selectedDateRange, conta?.idProduto);
                  }}
                  me="18px"
                  bg="unset"
                  _selected={{
                    bg: "none",
                  }}
                  _focus={{ border: "none" }}
                  border="0px solid transparent !important"
                  _active={{ bg: "none" }}
                  minW="max-content"
                >
                  <Box
                    w="18px"
                    height="18px"
                    transition="0.1s linear"
                    bg={
                      tabState === x
                        ? conta?.idProduto === 1
                          ? window.config.tenant === "Jae"
                            ? "#55CAC1"
                            : "#2A85BD"
                          : conta?.idProduto === 2 || conta?.idProduto === 6
                            ? "#000"
                            : "#E5B02D"
                        : "secondaryGray.500"
                    }
                    borderRadius="50%"
                  />
                </Tab>
              ))
              : null}
            {/* </Flex> */}
          </TabList>

          <TabPanels mb="20px">
            {midiasContaPrincipal.map((conta: any, i: number) => (
              <TabPanel p="0px" key={i}>
                <Flex
                  justify="space-between"
                  px="10px"
                  pt="5px"
                  mb="25px"
                  align="center"
                >
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight={"700"}
                    lineHeight="100%"
                  >
                    {window.config.tenant === "Partiu" ? (
                      <>
                        {conta?.idProduto === 1 && "Conta Partiu"}
                        {conta?.idProduto === 2 && "Partiu VT"}
                        {conta?.idProduto === 3 && "Partiu Gratuidade"}
                        {conta?.idProduto === 6 && "Conta Transporte"}
                      </>
                    ) : window.config.tenant === "Jae" ? (
                      <>
                        {conta?.idProduto === 1 && "Conta Jae"}
                        {conta?.idProduto === 2 && "Benefício VT"}
                        {conta?.idProduto === 3 && "Jaé Gratuidade"}
                        {conta?.idProduto === 6 && "Conta Transporte"}
                      </>
                    ) : window.config.tenant === "macae" ? (
                      <>
                        {conta?.idProduto === 1 &&
                          "Conta Educa + Macaé Benefício"}
                      </>
                    ) : (
                      <>
                        {conta?.idProduto === 1 && "Conta Jaé"}
                        {conta?.idProduto === 2 && "Benefício VT"}
                        {conta?.idProduto === 3 && "Jaé Gratuidade"}
                        {conta?.idProduto === 6 && "Conta Transporte"}
                      </>
                    )}
                  </Text>
                </Flex>

                <Flex
                  justify="space-between"
                  p="20px"
                  mb="20px"
                  borderRadius="16px"
                  visibility={loading ? "hidden" : "visible"}
                  bgColor={
                    contaBloqueada === true
                      ? "red.500"
                      : conta?.idProduto === 1
                        ? window.config.tenant === "Jae"
                          ? "#55CAC1"
                          : window.config.tenant === "macae"
                            ? "purple.700"
                            : "#2A85BD"
                        : conta?.idProduto === 2 || conta?.idProduto === 6
                          ? "#000"
                          : "#E5B02D"
                  }
                  bgImage={balanceImg}
                  bgPosition="right"
                  bgSize="cover"
                >
                  <Flex align="center" justify="space-between" w="100%">
                    <Flex flexDirection="column" me="20px" w={fraude && "100%"}>
                      <Flex
                        flexDirection="column"
                        me={{ base: "0px", md: "20px" }}
                        justifyItems={"start"}
                        alignItems={"start"}
                      >
                        {(contaBloqueada || valorBloqueado) && (
                          <Flex
                            flexDirection="column"
                            justifyItems={"center"}
                            alignItems={"left"}
                            width={"100%"}
                            mb={"5px"}
                          >
                            {contaBloqueada && (
                              <Text
                                color="white"
                                fontSize="md"
                                fontWeight="400"
                              >
                                <b>
                                  Conta ou valor bloqueados por uso fora do
                                  padrão.
                                </b>
                                <br /> Para mais informações e regularização, o
                                beneficiário deve abrir um chamado para
                                tratativa do time de Backoffice.
                              </Text>
                            )}
                            {valorBloqueado && (
                              <Text
                                color={conta?.idProduto === 3 ? "red" : "white"}
                                fontSize="md"
                                fontWeight="700"
                              >
                                O Valor{" "}
                                {formatCurrencyFloor(
                                  valorBloqueadoConta ||
                                  valorBloqueadoContaIndevida,
                                )}{" "}
                                foi bloqueado.
                              </Text>
                            )}
                          </Flex>
                        )}

                        {penalizacaoGratuidade.length > 0 &&
                          idProduto === 3 && (
                            <Flex
                              direction="column"
                              w={{ base: "100%", md: "500px" }}
                              mb="10px"
                              mt="10px"
                              bg="white"
                              borderRadius="md"
                              boxShadow="md"
                              p="16px"
                            // limite de altura
                            // ativa scroll
                            >
                              <Flex
                                fontWeight="semibold"
                                color="gray.600"
                                direction={"column"}
                                borderBottom="1px solid #eee"
                                alignItems={"flex-start"}
                                pb="8px"
                                mb="8px"
                                align="center"
                              >
                                <Text
                                  fontWeight="bold"
                                  fontSize="lg"
                                  mb="5px"
                                  color="red.600"
                                  letterSpacing="wide"
                                >
                                  Transações biométricas com uso indevido{" "}
                                </Text>
                              </Flex>

                              {loading ? (
                                <Flex
                                  justify="center"
                                  px="10px"
                                  pt="5px"
                                  mb="25px"
                                >
                                  <CircularProgress
                                    isIndeterminate
                                    color="green.300"
                                    size="40px"
                                  />
                                </Flex>
                              ) : (
                                <Flex
                                  maxH={
                                    penalizacaoGratuidade.length > 5
                                      ? "250px"
                                      : "none"
                                  }
                                  direction="column"
                                  overflowY={
                                    penalizacaoGratuidade.length > 5
                                      ? "auto"
                                      : "visible"
                                  }
                                >
                                  {penalizacaoGratuidade.length > 0 &&
                                    penalizacaoGratuidade.map(
                                      (item: any, index: number) => (
                                        <>
                                          <TransacoesFraude
                                            key={index}
                                            modal={listaModais}
                                            operadoras={listaOperadoras}
                                            midias={listaMidias}
                                            item={[item]}
                                          />
                                        </>
                                      ),
                                    )}
                                </Flex>
                              )}

                              {usuarios[0]?.perfis.some((perfil: string) =>
                                atendenteAuditoria.includes(perfil),
                              ) &&
                                podeDesbloquarConta && (
                                  <Flex
                                    alignContent={"right"}
                                    justifyContent={"right"}
                                  >
                                    <Button
                                      leftIcon={<MdFingerprint />}
                                      colorScheme="brand"
                                      mr={3}
                                      isDisabled={fraude}
                                      mt={"25px"}
                                      width={{ base: "100%", md: "250px" }}
                                      onClick={() =>
                                        onChangeModalBloqueioIndevido()
                                      }
                                    >
                                      Desbloquear conta
                                    </Button>
                                  </Flex>
                                )}
                            </Flex>
                          )}

                        <Text color="white" fontSize="md" fontWeight="700">
                          Saldo{" "}
                          {valorBloqueadoContaIndevida !== 0 &&
                            " - Valor bloqueado : R$" +
                            valorBloqueadoContaIndevida}
                          :
                        </Text>

                        <Text
                          color={"white"}
                          fontSize="34px"
                          fontWeight="700"
                          lineHeight="100%"
                          textDecoration={
                            valorBloqueadoContaIndevida
                              ? "none"
                              : contaBloqueada && "line-through"
                          }
                        >
                          {conta?.idProduto === 1 ||
                            conta?.idProduto === 2 ||
                            conta?.idProduto === 6
                            ? formatCurrencyFloor(
                              conta?.valorSaldo -
                              valorBloqueadoContaIndevida || 0.0,
                            )
                            : null}
                          {conta?.idProduto === 3 &&
                            conta?.quantidadeSaldo > 10000
                            ? "Ilimitado"
                            : conta?.quantidadeSaldo}
                        </Text>
                        {!isEmpty(laudo) &&
                          conta?.idProduto === 3 &&
                          conta?.quantidadeSaldo < 10000 &&
                          conta?.quantidadeSaldo !== 76 &&
                          limite !== 0 ? (
                          <>
                            <Text
                              color="white"
                              fontSize="sm"
                              fontWeight="500"
                              mt={"10px"}
                            >
                              Quantidade passagem mensal{" "}
                            </Text>
                            <Text
                              color="white"
                              fontSize="34px"
                              fontWeight="700"
                              lineHeight="100%"
                              mb={"10px"}
                            >
                              {acompanhante
                                ? limite * 2 + limitePassagensEstudante
                                : limite + limitePassagensEstudante}
                            </Text>
                          </>
                        ) : null}
                      </Flex>

                      {conta?.idProduto === 3 ? (
                        <>
                          <Text
                            color="white"
                            fontSize="sm"
                            fontWeight="400"
                            lineHeight="100%"
                            mt={"10px"}
                          >
                            {conta?.quantidadeSaldo > 10000
                              ? "Validade indeterminada"
                              : laudo[0]?.dataFimValidade
                                ? ""
                                : null}
                            {/* {conta?.quantidadeSaldo > 10000
                              ? "Validade indeterminada"
                              : laudo[0]?.dataFimValidade
                              ? "Validade: " +
                                maskDataLaudoSemHora(laudo[0]?.dataInclusao) +
                                " até " +
                                maskDataLaudoSemHoraMaisUm(
                                  laudo[0]?.dataFimValidade
                                )
                              : null} */}
                          </Text>
                          <Flex
                            flexDirection="row"
                            justify="space-between"
                            align="flex-end"
                          >
                            <>
                              <Flex flexDirection="row" mt={5}>
                                <Icon
                                  as={MdFingerprint}
                                  color={"white"}
                                  w="20px"
                                  h="18px"
                                />
                                <Text
                                  color="white"
                                  fontSize="sm"
                                  fontWeight="700"
                                  lineHeight="100%"
                                  mt={1}
                                  ml={1}
                                >
                                  {laudo[0]?.desativarBiometriaFacial ===
                                    true || biometria === true
                                    ? "Biometria desativada"
                                    : "Biometria ativada"}
                                </Text>
                              </Flex>
                            </>

                            <>
                              {acompanhante && (
                                <Flex flexDirection="row" mt={5} ml={20}>
                                  <Icon
                                    as={MdPeopleAlt}
                                    color={"white"}
                                    w="20px"
                                    h="18px"
                                  />
                                  <Text
                                    color={"white"}
                                    fontSize="sm"
                                    fontWeight="700"
                                    lineHeight="100%"
                                    mt={1}
                                    ml={1}
                                  >
                                    {valorAtualAcompanhantePCD
                                      ? "Possui acompanhante"
                                      : "Acompanhante vencido"}
                                  </Text>
                                </Flex>
                              )}

                              {conta?.midias[0]?.idTipoMidia === 4 && (
                                <Flex flexDirection="row" mt={5} ml={20}>
                                  <Icon
                                    as={MdAddCard}
                                    color={"white"}
                                    w="20px"
                                    h="18px"
                                  />
                                  <Text
                                    color="white"
                                    fontSize="sm"
                                    fontWeight="700"
                                    lineHeight="100%"
                                    mt={1}
                                    ml={1}
                                  >
                                    Cartão VISA
                                  </Text>
                                </Flex>
                              )}
                            </>
                          </Flex>
                          {historicoGratuidade.length > 0
                            ? historicoGratuidade.map(
                              (gratuidade: any, index: number) =>
                                gratuidade.statusGratuidade && (
                                  <Flex
                                    key={index}
                                    justifyContent="center"
                                    mt="15px"
                                    alignItems="center"
                                    w="100%"
                                  >
                                    <IconBox
                                      h="22px"
                                      w="22px"
                                      bg={iconBoxBg}
                                      me="20px"
                                      icon={statusIcon(
                                        gratuidade.idGratuidade,
                                      )}
                                    />

                                    <Flex
                                      direction="column"
                                      align="start"
                                      me="auto"
                                    >
                                      <Text
                                        color={textGrayBg}
                                        fontSize="sm"
                                        fontWeight="500"
                                      >
                                        {descricaoCor(
                                          gratuidade.descricaoGratuidade,
                                          gratuidade.statusGratuidade,
                                        )}{" "}
                                        {!contaBloqueadaPcd &&
                                          !contaBloqueadaSenior &&
                                          gratuidade.idGratuidade === 3 &&
                                          dataFimValidadeRegraPcd &&
                                          !isIlimitado && (
                                            <Text
                                              color={
                                                !isDataCancelada(
                                                  dataFimValidadeRegraPcd,
                                                )
                                                  ? "white"
                                                  : "red.600"
                                              }
                                              fontSize="small"
                                              fontWeight="500"
                                            >
                                              {!isIlimitado &&
                                                !isDataCancelada(
                                                  dataFimValidadeRegraPcd,
                                                )
                                                ? "Válida até:"
                                                : "Vencida em:"}{" "}
                                              {maskDataHistoricoSemHora(
                                                dataFimValidadeRegraPcd,
                                              )}
                                            </Text>
                                          )}
                                        {dataFimValidadeRegraEstudante &&
                                          gratuidade.idGratuidade === 1 && (
                                            <Text
                                              color={
                                                !isDataCancelada(
                                                  dataFimValidadeRegraEstudante,
                                                )
                                                  ? "white"
                                                  : "red.600"
                                              }
                                              fontSize="small"
                                              fontWeight="500"
                                            >
                                              {!isIlimitado &&
                                                !isDataCancelada(
                                                  dataFimValidadeRegraEstudante,
                                                )
                                                ? "Válida até:"
                                                : "Vencida em:"}{" "}
                                              {maskDataHistoricoSemHora(
                                                dataFimValidadeRegraEstudante,
                                              )}
                                            </Text>
                                          )}
                                      </Text>
                                    </Flex>
                                  </Flex>
                                ),
                            )
                            : null}
                        </>
                      ) : null}
                    </Flex>
                    <Flex
                      flexDirection="column"
                      ms="auto"
                      justify="space-between"
                      align="flex-end"
                    >
                      <Image
                        src={fakeGraph}
                        w={fraude && conta?.idProduto === 3 ? "40px" : "59px"}
                        h={fraude && conta?.idProduto === 3 ? "35px" : "34px"}
                      />
                    </Flex>
                  </Flex>
                </Flex>

                <Tabs>
                  <TabPanels mb="50px">
                    {conta.midias.map(
                      (cartao: any, index: number) =>
                        (cartao.idTipoMidia === 1 ||
                          cartao.idTipoMidia === 4) &&
                        !isEmpty(cartao?.numeroLogico) && (
                          <TabPanel p="0px" key={index}>
                            <Mastercard
                              number={maskNumeroMidia(cartao.numeroLogico)}
                              saldo={cartao.saldo}
                              dataUser={dataUser}
                              cartao={cartao}
                              tipo={cartao.idProduto}
                              qtdSaldo={0}
                            />
                          </TabPanel>
                        ),
                    )}
                  </TabPanels>
                </Tabs>
                <Modal
                  isOpen={modalData}
                  onClose={onChangeModalDataClose}
                  size={{ base: "full", md: "md" }}
                >
                  <ModalOverlay />
                  <ModalContent alignSelf={"center"}>
                    <ModalHeader>Escolha o período</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody p={0}>
                      <Flex
                        justify="center"
                        align="center"
                        direction="column"
                        w="100%"
                        overflowX="auto"
                      >
                        {window.config.tenant !== "macae" ? (
                          <DateRangePicker
                            className="rdrDefinedRangesWrapper "
                            onChange={handleSelect}
                            moveRangeOnFirstSelection={false}
                            months={1}
                            showMonthAndYearPickers={true}
                            ranges={[selectedDateRange]}
                            direction="vertical"
                            locale={pt}
                            displayMode="date"
                            dragSelectionEnabled={true}
                            showDateDisplay={true}
                            headerContent={true}
                            scroll={{ enabled: false }}
                            showPreview={false}
                            dateDisplayFormat="dd MMM, yyyy"
                            editableDateInputs={false}
                            staticRanges={[]}
                            inputRanges={[]}
                          />
                        ) : (
                          <DateRangePicker
                            className="rdrDefinedRangesWrapper "
                            onChange={handleSelect}
                            ranges={[selectedDateRange]}
                            months={1}
                            direction="vertical"
                            locale={pt}
                            showDateDisplay={true}
                            editableDateInputs={false}
                            staticRanges={[]}
                            inputRanges={[]}
                          />
                        )}
                      </Flex>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        leftIcon={<MdSearch />}
                        colorScheme="brand"
                        mr={3}
                        onClick={() => {
                          onPesquisar(selectedDateRange);
                        }}
                      >
                        Pesquisar
                      </Button>
                    </ModalFooter>
                  </ModalContent>
                </Modal>
                <Modal
                  isOpen={modalPedidoCancelamento}
                  onClose={onChangeModalPedidoCancelamento}
                  size={{ base: "full", md: "md" }}
                >
                  <ModalOverlay />
                  <ModalContent alignSelf={"center"} alignContent={"center"}>
                    <ModalHeader>
                      Deseja realmente cancelar o pedido{" "}
                      {JSON.stringify(numeroPedido)} ?
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                      <Flex
                        justify="center"
                        align="center"
                        direction={{ base: "column", md: "row" }}
                        gap="10px"
                        minH={"122px"}
                        w={"100%"}
                      >
                        <Button
                          leftIcon={<HiOutlineCheck />}
                          colorScheme="green"
                          mr={3}
                          onClick={() => cancelarPedido(numeroPedido)}
                        >
                          Sim
                        </Button>
                        <Button
                          leftIcon={<HiXCircle />}
                          colorScheme="red"
                          onClick={() => setModalPedidoCancelamento(false)}
                        >
                          Não
                        </Button>
                      </Flex>
                    </ModalBody>
                    <ModalFooter></ModalFooter>
                  </ModalContent>
                </Modal>
                <Modal
                  isOpen={modalFinalizaCompra}
                  onClose={onChangeModalFinalizaCompra}
                  size={{ base: "full", md: "md" }}
                >
                  <ModalOverlay />
                  <ModalContent alignSelf={"center"}>
                    <ModalHeader>Finalizar pedido</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                      <Flex
                        justify="flex-start"
                        direction="column"
                        minH={"392px"}
                        w={"100%"}
                        mt={"12px"}
                      >
                        <Stack>
                          <Text>Confirme: </Text>
                          {statusSegundaVia === true && (
                            <Stack direction="row" gap="15px">
                              <Checkbox
                                mr="0px"
                                colorScheme="brandScheme"
                                checked={boletimOcorrencia}
                                isChecked={boletimOcorrencia}
                                onChange={(e) => {
                                  setBoletimOcorrencia(e.target.checked);
                                  setValorSegundaVia("0");
                                  if (e.target.checked === false) {
                                    setLoading(true);
                                    valor2Via(idProduto).then(
                                      function (result) {
                                        if (result) {
                                          const stringifyResponse2Via =
                                            JSON.stringify(result);
                                          const parsedResponse2Via = JSON.parse(
                                            stringifyResponse2Via,
                                          ); // ou parsedResponse["valorTaxa"]
                                          setValorSegundaVia(
                                            parsedResponse2Via?.valor,
                                          );
                                          setLoading(false);
                                        }
                                      },
                                    );
                                  }
                                }}
                              />
                              <Text
                                color={redIcon}
                                fontSize="md"
                                fontWeight="700"
                                display="flex"
                                alignItems="center"
                              >
                                Apresentou Boletim de Ocorrência (B.O.)
                              </Text>
                            </Stack>
                          )}
                          <Table
                            variant="striped"
                            h={"123px"}
                            colorScheme="blue"
                            w={"100%"}
                          >
                            <Tbody>
                              {statusSegundaVia ? (
                                <>
                                  <Tr>
                                    <Td>Taxa 2ª via</Td>
                                    <Td isNumeric>
                                      {formatCurrencyFloor(
                                        parseFloat(valorSegundaVia),
                                      )}
                                    </Td>
                                  </Tr>
                                  <Tr>
                                    <Td>Taxa envio</Td>
                                    <Td isNumeric>
                                      {formatCurrencyFloor(
                                        parseFloat(taxaEnvio),
                                      )}
                                    </Td>
                                  </Tr>
                                </>
                              ) : (
                                <>
                                  <Tr>
                                    <Td>Taxa 1º via</Td>
                                    <Td isNumeric>
                                      {formatCurrencyFloor(
                                        parseFloat(
                                          idProduto === 3 && !statusSegundaVia
                                            ? "0,00"
                                            : statusSegundaVia
                                              ? valorSegundaVia
                                              : valorPrimeiraVia,
                                        ),
                                      )}
                                    </Td>
                                  </Tr>

                                  <Tr>
                                    <Td>Taxa de entrega </Td>
                                    <Td isNumeric>
                                      {formatCurrencyFloor(
                                        parseFloat(
                                          idProduto === 3 &&
                                            statusSegundaVia === false &&
                                            onViewRatioEndereco === "loja"
                                            ? "0,00"
                                            : taxaEnvio,
                                        ),
                                      )}
                                    </Td>
                                  </Tr>
                                </>
                              )}
                              <Tr>
                                <Td>Valor total:</Td>

                                <Td isNumeric>
                                  <b></b>
                                  {formatCurrencyFloor(
                                    statusSegundaVia
                                      ? Number.parseFloat(valorSegundaVia) +
                                      Number.parseFloat(taxaEnvio)
                                      : idProduto === 3 && !statusSegundaVia
                                        ? Number.parseFloat("0,00")
                                        : Number.parseFloat(valorPrimeiraVia) +
                                        Number.parseFloat(taxaEnvio),
                                  )}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td colSpan={2}>
                                  {statusSegundaVia &&
                                    boletimOcorrencia === false && (
                                      <>
                                        <Text
                                          color="-moz-initial"
                                          fontSize="sm"
                                          fontWeight="700"
                                          lineHeight="100%"
                                          mb={"10px"}
                                        >
                                          Selecione o método de pagamento
                                        </Text>
                                        <Select
                                          isRequired={true}
                                          id="metodoPagamento"
                                          name="metodoPagamento"
                                          h="44px"
                                          fontSize="sm"
                                          fontWeight="500"
                                          borderRadius="16px"
                                          value={metodoPagamento}
                                          onChange={(e) =>
                                            handleChangeMetodoPagamento(e)
                                          }
                                        >
                                          <option value="" selected>
                                            Método de pagamento
                                          </option>
                                          <option value="BOLETO">Boleto</option>
                                        </Select>
                                      </>
                                    )}
                                </Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        </Stack>
                      </Flex>
                    </ModalBody>
                    <ModalFooter>
                      <Flex justify="center" direction="row">
                        <Button
                          mt={"16px"}
                          mb={"56px"}
                          mr={"18px"}
                          alignSelf={"flex-end"}
                          variant="brand"
                          data-testid="voltarPrimeiraRecarga"
                          width={"130px"}
                          height={"40px"}
                          onClick={onVoltarPrimeiraRecarga}
                        >
                          Voltar
                        </Button>
                        <Button
                          mt={"16px"}
                          mb={"56px"}
                          alignSelf={"flex-end"}
                          data-testid="finalizarPedido"
                          variant="brand"
                          disabled={
                            metodoPagamento !== "" ||
                              statusSegundaVia === false ||
                              boletimOcorrencia === true
                              ? false
                              : true
                          }
                          width={"180px"}
                          height={"40px"}
                          loadingText="Finalizando..."
                          onClick={() =>
                            loading === false
                              ? finalizarPedido(idProduto)
                              : null
                          }
                          isLoading={loading}
                        >
                          Finalizar
                        </Button>
                      </Flex>
                    </ModalFooter>
                  </ModalContent>
                </Modal>
                <Modal
                  isOpen={modalUsoIndevido}
                  onClose={onChangeModalUsoIndevido}
                  size={"sm"}
                >
                  <ModalOverlay />
                  <ModalContent alignSelf={"center"} alignContent={"center"}>
                    <ModalHeader>
                      Conta ou valor bloqueados por uso fora do padrão.
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                      <Flex
                        justify="center"
                        align="center"
                        h={"122px"}
                        direction={"column"}
                        w={"-moz-max-content"}
                      >
                        <Text
                          color={redIcon}
                          fontSize="md"
                          fontWeight="700"
                          display="flex"
                          alignItems="center"
                        >
                          Não é permitida nenhuma ação. Para mais informações e
                          regularização, o beneficiário deve abrir um chamado
                          para tratativa do time de Backoffice.
                        </Text>
                      </Flex>
                    </ModalBody>
                    <ModalFooter></ModalFooter>
                  </ModalContent>
                </Modal>

                <PopOverAlertOrange
                  handleOpenAlert={handleOpenAlertErro}
                  isOpen={isOpenErro}
                  title="Ops..."
                  subtitle={tipoErroPedido}
                />
                <PopOverAlertGreen
                  handleOpenAlertSucess={handleOpenAlertGreen}
                  isOpen={isOpenGreen}
                  title="Ok..."
                  subtitle={msgStatusOk}
                />
                <Modal
                  isOpen={modalPedidoCartao}
                  onClose={onCloseModalPedidoCartao}
                  size={"sm"}
                >
                  <ModalOverlay />
                  <ModalContent
                    alignSelf={"center"}
                    h={lojaSelect ? "580px" : "580px"}
                  >
                    <ModalHeader>
                      {viewPassoUm
                        ? "Onde receber o cartão"
                        : statusSegundaVia
                          ? "Pedido 2º via"
                          : "Primeira via"}{" "}
                    </ModalHeader>
                    <ModalCloseButton />
                    {viewPassoUm ? (
                      <ModalBody>
                        <Flex justify="flex-start" direction={"column"}>
                          <RadioGroup
                            onChange={(e) => onChangeRadioEndereco(e)}
                            defaultValue={"loja"}
                            defaultChecked={true}
                          >
                            <Flex justify="center" direction={"column"}>
                              <Stack width={"100%"} direction={"row"}>
                                <Radio value="loja" checked>
                                  Retirada na loja
                                </Radio>
                                <Icon
                                  as={MdStore}
                                  color={iconColor}
                                  w="24px"
                                  h="24px"
                                />
                              </Stack>
                              <Stack width={"100%"} direction={"row"}>
                                <Radio value="casa">
                                  Enviar para residência do cliente
                                </Radio>
                                <Icon
                                  as={MdHome}
                                  color={iconColor}
                                  w="24px"
                                  h="24px"
                                />
                              </Stack>
                            </Flex>
                            <Text
                              fontSize="sm"
                              fontWeight="300"
                              color={textColor}
                              mt={"20px"}
                            >
                              {
                                onViewRatioEndereco === "loja"
                                  ? "A retirada do cartão na loja não possui taxa de entrega e o prazo de entrega é de até 10 dias úteis."
                                  : "A entrega do cartão no endereço possui taxa de entrega."
                                // + formatCurrencyFloor(taxaEnvio) +
                                //" e o prazo de recebimento é de até 15 dias úteis, após o pagamento do boleto."
                              }
                            </Text>
                          </RadioGroup>
                        </Flex>

                        {loading ? (
                          <Flex justify="center" px="10px" pt="5px" mb="25px">
                            <CircularProgress
                              isIndeterminate
                              color="green.300"
                              size="40px"
                            />
                          </Flex>
                        ) : onViewRatioEndereco === "loja" ? (
                          <Flex justify="center" mt={"12px"} direction="column">
                            <Select
                              isRequired={true}
                              id="lojas"
                              name="lojasApi"
                              h="44px"
                              isDisabled={loading ? true : false}
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="16px"
                              value={lojaSelect}
                              onChange={(e) => handleChangeSelectLojaCasa(e)}
                            >
                              <option value="0" selected>
                                Selecione a loja
                              </option>
                              {lojas
                                .filter((item) => item.codigo !== 733)
                                .map((option, index) =>
                                  lojas ? (
                                    <option key={index} value={option.codigo}>
                                      {option.nome}
                                    </option>
                                  ) : null,
                                )}
                            </Select>
                            {lojas.map((option, index) =>
                              parseInt(option.codigo) === lojaSelect ? (
                                <Box
                                  key={index}
                                  borderWidth="1px"
                                  borderRadius="lg"
                                  overflow="hidden"
                                  w={"full"}
                                  mt={"16px"}
                                >
                                  <Text
                                    fontSize="small"
                                    fontWeight="300"
                                    color={textColor}
                                    mt={"20px"}
                                    ml={"17px"}
                                  >
                                    <b>Endereço:</b>{" "}
                                    {option?.enderecos[0]?.logradouro},{" "}
                                    {option?.enderecos[0]?.numero}
                                    {option?.enderecos[0]?.complemento}
                                  </Text>
                                  <Text
                                    fontSize="small"
                                    fontWeight="300"
                                    color={textColor}
                                    mt={"20px"}
                                    ml={"17px"}
                                  >
                                    <b>Bairro:</b>{" "}
                                    {option?.enderecos[0]?.bairro}
                                  </Text>
                                  <Text
                                    fontSize="small"
                                    fontWeight="300"
                                    color={textColor}
                                    mt={"20px"}
                                    ml={"17px"}
                                  >
                                    <b>Cidade:</b>{" "}
                                    {option?.enderecos[0]?.cidade}
                                  </Text>
                                  <Text
                                    fontSize="small"
                                    fontWeight="300"
                                    color={textColor}
                                    mt={"20px"}
                                    ml={"17px"}
                                    mb={"17px"}
                                  >
                                    <b>Cep:</b> {option?.enderecos[0]?.cep}
                                  </Text>
                                </Box>
                              ) : null,
                            )}
                          </Flex>
                        ) : cep || enderecoTO[0]?.cep ? (
                          <Flex
                            justify="flex-start"
                            mt={"12px"}
                            visibility={viewPassoUm ? "visible" : "hidden"}
                          >
                            <Box
                              borderWidth="1px"
                              borderRadius="lg"
                              overflow="hidden"
                              w={"full"}
                            >
                              <Stack ml={"12px"} mb={"20px"}>
                                <Text
                                  fontSize="small"
                                  fontWeight="300"
                                  color={textColor}
                                  mt={"20px"}
                                >
                                  <b>Endereço: </b>{" "}
                                  {logradouro || enderecoTO[0]?.logradouro} -{" "}
                                  {complemento || enderecoTO[0]?.complemento}
                                </Text>
                                <Text
                                  fontSize="small"
                                  fontWeight="300"
                                  color={textColor}
                                  mt={"20px"}
                                >
                                  <b>Bairro:</b>{" "}
                                  {bairro || enderecoTO[0]?.bairro}
                                </Text>
                                <Text
                                  fontSize="small"
                                  fontWeight="300"
                                  color={textColor}
                                  mt={"20px"}
                                >
                                  <b>Cidade:</b>{" "}
                                  {cidade || enderecoTO[0]?.cidade}
                                </Text>
                                <Text
                                  fontSize="small"
                                  fontWeight="300"
                                  color={textColor}
                                  mt={"20px"}
                                >
                                  <b>Cep:</b> {cep || enderecoTO[0]?.cep}
                                </Text>
                              </Stack>
                            </Box>
                          </Flex>
                        ) : (
                          <Text
                            fontSize="small"
                            fontWeight="300"
                            color={textColor}
                            mt={"20px"}
                            ml={"17px"}
                            mb={"17px"}
                          >
                            <b>
                              Cadastre um endereço para o cliente antes de
                              solicitar o cartão.
                            </b>
                          </Text>
                        )}
                        <Flex justify="flex-end" mt={"32px"}>
                          <Button
                            disabled={
                              viewBotaoProsseguir ||
                                (lojaSelect === 0 &&
                                  onViewRatioEndereco === "loja") ||
                                (onViewRatioEndereco == "casa" &&
                                  !cep &&
                                  !enderecoTO[0]?.cep)
                                ? true
                                : false
                            }
                            colorScheme="brand"
                            mr={3}
                            isLoading={loading}
                            onClick={() => {
                              if (midiasContaPrincipal[tabState]?.idProduto) {
                                onProsseguir(
                                  midiasContaPrincipal[tabState].idProduto,
                                );
                              } else {
                                console.error(
                                  "Produto inválido ou não encontrado!",
                                );
                              }
                              taxaEntrega();
                            }}
                          >
                            Prosseguir
                          </Button>
                        </Flex>
                      </ModalBody>
                    ) : null}
                    <ModalFooter></ModalFooter>
                  </ModalContent>
                </Modal>
                {loading ? (
                  <Flex justify="center" px="10px" pt="5px" mb="25px">
                    <CircularProgress
                      isIndeterminate
                      color="green.300"
                      size="40px"
                    />
                  </Flex>
                ) : (
                  <Flex
                    justifyContent={"center"}
                    align={"center"}
                    direction={"column"}
                  >
                    <Flex
                      direction="column"
                      bg={boxBg}
                      p="16px 20px"
                      borderRadius="14px"
                      mb="18px"
                      align={"center"}
                      //justifyItems={"center"}
                      textAlign={"center"}
                      w={"444px"}
                    >
                      {midiasContaPrincipal[tabState]?.midias[0]
                        ?.descricaoStatusMidia === "PENDENTE_ASSOCIACAO" && (
                          <Text
                            fontSize={
                              midiasContaPrincipal[tabState].midias[0]
                                ?.descricaoStatusMidia === "PENDENTE_ASSOCIACAO"
                                ? "lg"
                                : "sm"
                            }
                            fontWeight="500"
                            color={
                              midiasContaPrincipal[tabState]?.midias[0]
                                ?.descricaoStatusMidia === "PENDENTE_ASSOCIACAO"
                                ? "red"
                                : "black"
                            }
                            alignSelf={"center"}
                          >
                            {midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia ===
                              "PENDENTE_ASSOCIACAO" && (
                                <div>
                                  Cliente possui cartão pendente de associação.
                                  <br />O cliente deve ir a um ATM para confirmar
                                  associação.
                                </div>
                              )}
                          </Text>
                        )}
                      {loading ? null : !contaBloqueada &&
                        existePedido === false &&
                        (tipoPedidoCartao == "PODE SOLICITAR PRIMEIRA_VIA" ||
                          tipoPedidoCartao == "PODE SOLICITAR SEGUNDA_VIA" ||
                          podeAssociarCartao) ? (
                        <Flex direction={"row"} justify={"center"} mb="25px">
                          {(midiasContaPrincipal[tabState]?.midias[0]
                            ?.descricaoStatusMidia !== "PENDENTE_ASSOCIACAO" &&
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia !== "EM_USO" &&
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia !== "BLOQUEADA" &&
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia === "BLOQUEADO_ENTREGA" &&
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia ===
                            "BLOQUEADA_SUSPEITA_FRAUDE" &&
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia === "EM_PRODUCAO" &&
                            ((pedidoSegundaVia === false &&
                              pedidoPrimeiraVia == false) ||
                              podeAssociarCartao) &&
                            midiasContaPrincipal[tabState]?.idProduto !== 1 &&
                            midiasContaPrincipal[tabState]?.idProduto !== 2) ||
                            (midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia === undefined &&
                              !usuarios[0]?.perfis.some((perfil: string) =>
                                perfisConsultaEstudante.includes(perfil),
                              ) && (
                                <>
                                  <Flex
                                    direction="row"
                                    gap="5px"
                                    align="center"
                                  >
                                    <Button
                                      alignSelf={"center"}
                                      leftIcon={<MdOutlineCardGiftcard />}
                                      variant="brand"
                                      bgColor={
                                        midiasContaPrincipal[tabState]
                                          .idProduto === 3
                                          ? "#E5B02D"
                                          : midiasContaPrincipal[tabState]
                                            .idProduto !== 3
                                            ? "black"
                                            : "brand"
                                      }
                                      width={"180px"}
                                      height={"30px"}
                                      mt={"6px"}
                                      loadingText="Solicitando..."
                                      isLoading={loading}
                                      disabled={
                                        solicitarCartao === false &&
                                        usoIndevido === false &&
                                        (midiasContaPrincipal[tabState]
                                          ?.idProduto === 1 ||
                                          midiasContaPrincipal[tabState]
                                            ?.idProduto === 2)
                                      }
                                      onClick={() =>
                                        onChangeModalPedidoCartao()
                                      }
                                      onMouseEnter={() => setIsHovered2(true)}
                                      onMouseLeave={() => setIsHovered2(false)}
                                    >
                                      Solicitar cartão
                                    </Button>

                                    <>
                                      <Button
                                        alignSelf={"center"}
                                        leftIcon={<MdOutlineCardGiftcard />}
                                        variant="brand"
                                        bgColor={
                                          midiasContaPrincipal[tabState]
                                            .idProduto === 3
                                            ? "#E5B02D"
                                            : midiasContaPrincipal[tabState]
                                              .idProduto !== 3
                                              ? "black"
                                              : "brand"
                                        }
                                        width={"180px"}
                                        height={"30px"}
                                        mt={"6px"}
                                        disabled={
                                          window.config.tenant !== "Partiu" &&
                                          usoIndevido === false &&
                                          midiasContaPrincipal[tabState]
                                            ?.idProduto !== 3 &&
                                          midiasContaPrincipal[tabState]
                                            ?.idProduto !== 6
                                        }
                                        onClick={() =>
                                          setModalAssociarCartao(true)
                                        }
                                        onMouseEnter={() => setIsHovered(true)}
                                        onMouseLeave={() => setIsHovered(false)}
                                      >
                                        Associar cartão{" "}
                                      </Button>
                                    </>
                                  </Flex>
                                </>
                              ))}
                        </Flex>
                      ) : null}

                      {!contaBloqueada &&
                        midiasContaPrincipal[tabState].idProduto === 3 &&
                        midiasContaPrincipal[tabState].midias[0]
                          ?.descricaoStatusMidia !== "EM_USO" &&
                        midiasContaPrincipal[tabState].midias[0]
                          ?.descricaoStatusMidia !== "ASSOCIADA" &&
                        !usoIndevido &&
                        !podeAssociarCartao &&
                        existePedido ? (
                        <>
                          <Flex
                            direction="row"
                            gap="5px"
                            align="center"
                            mb={"25px"}
                          >
                            <Button
                              alignSelf={"center"}
                              leftIcon={<MdOutlineCardGiftcard />}
                              variant="brand"
                              bgColor={
                                midiasContaPrincipal[tabState].idProduto === 3
                                  ? "#E5B02D"
                                  : isHovered
                                    ? "a8a8a8ff"
                                    : null
                              }
                              width={"180px"}
                              height={"30px"}
                              mt={"6px"}
                              disabled={
                                solicitarCartao === false &&
                                usoIndevido === false &&
                                (midiasContaPrincipal[tabState]?.idProduto ===
                                  1 ||
                                  midiasContaPrincipal[tabState]?.idProduto ===
                                  2)
                              }
                              onClick={() => setModalPedidoCancelamento(true)}
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                            >
                              Cancelar pedido
                            </Button>
                            {!existePedido && podeAssociarCartao && (
                              <>
                                <Button
                                  alignSelf={"center"}
                                  leftIcon={<MdOutlineCardGiftcard />}
                                  variant="brand"
                                  bgColor={
                                    midiasContaPrincipal[tabState].idProduto ===
                                      3
                                      ? "#E5B02D"
                                      : isHovered
                                        ? "red"
                                        : null
                                  }
                                  width={"180px"}
                                  height={"30px"}
                                  mt={"6px"}
                                  disabled={
                                    usoIndevido === false &&
                                    (pedidoPrimeiraVia || pedidoSegundaVia) &&
                                    midiasContaPrincipal[tabState]
                                      ?.idProduto !== 3
                                  }
                                  onClick={() => setModalAssociarCartao(true)}
                                  onMouseLeave={() => setIsHovered(false)}
                                >
                                  Associar cartão{" "}
                                </Button>
                              </>
                            )}
                          </Flex>
                        </>
                      ) : null}

                      {!contaBloqueada &&
                        existePedido &&
                        !podeAssociarCartao &&
                        midiasContaPrincipal[tabState]?.midias[0]
                          ?.descricaoStatusMidia !== "EM_USO" &&
                        midiasContaPrincipal[tabState]?.midias[0]
                          ?.descricaoStatusMidia !== "CRIADA" &&
                        midiasContaPrincipal[tabState]?.midias[0]
                          ?.descricaoStatusMidia !== "ASSOCIADA" &&
                        midiasContaPrincipal[tabState]?.midias[0]
                          ?.descricaoStatusMidia !== "ASSOCIADA" ? (
                        <>
                          <Text
                            fontSize="sm"
                            fontWeight="700"
                            color={textColor}
                            alignSelf={"center"}
                          >
                            {midiasContaPrincipal[tabState]?.midias[0]
                              ?.idProduto == 6
                              ? contaBloqueada
                                ? "Conta Bloqueada!"
                                : "O saldo é atualizado automaticamente após cada utilização."
                              : pedidoSegundaVia
                                ? "Existe um pedido de 2º via para este usuário!"
                                : "Existe um pedido de 1º via para este usuário!"}
                          </Text>
                        </>
                      ) : (
                        <>
                          <Text
                            fontSize="sm"
                            fontWeight="700"
                            color={textColor}
                            alignSelf={"center"}
                          >
                            {contaBloqueada
                              ? "Conta Bloqueada!"
                              : "O saldo é atualizado automaticamente após cada utilização."}
                          </Text>
                          {midiasContaPrincipal[tabState]?.midias[0]
                            ?.descricaoStatusMidia === "ASSOCIADA" && (
                              <Text
                                fontSize="md"
                                fontWeight="700"
                                color={redIcon}
                                alignSelf={"center"}
                              >
                                Cartão em produção!
                              </Text>
                            )}
                        </>
                      )}
                    </Flex>

                    {!contaBloqueada &&
                      !IsEmpty(midiasContaPrincipal) &&
                      !isEmpty(
                        midiasContaPrincipal[tabState]?.midias[0]?.numeroLogico,
                      ) &&
                      !usuarios[0]?.perfis.some((perfil: string) =>
                        perfisConsultaEstudante.includes(perfil),
                      ) ? (
                      <>
                        <Flex mb="40px" ml={"20px"} alignSelf="center">
                          {(!contaBloqueada &&
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia === "BLOQUEADA") ||
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia === "BLOQUEADO_ENTREGA" ||
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia ===
                            "BLOQUEADO_SUSPEITA_FRAUDE" ||
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia === "EM_USO" ||
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia === "ASSOCIADA" ||
                            midiasContaPrincipal[tabState]?.midias[0]
                              ?.descricaoStatusMidia === "ATIVO" ? (
                            <>
                              <Flex
                                direction="column"
                                alignItems={"center"}
                                me={{
                                  base: "22px",
                                  md: "40px",
                                  "2xl": "36px",
                                }}
                              >
                                <IconButton
                                  aria-label="Transfer"
                                  borderRadius="50%"
                                  //bg={bgIconButton}
                                  _hover={bgIconHover}
                                  _active={bgIconFocus}
                                  _focus={bgIconFocus}
                                  w="56px"
                                  h="56px"
                                  mb="5px"
                                  boxShadow={shadow}
                                  onClick={onModalBloqueio}
                                  icon={
                                    <Icon
                                      as={
                                        midiasContaPrincipal[tabState]
                                          ?.midias[0]?.descricaoStatusMidia ===
                                          "BLOQUEADA" ||
                                          midiasContaPrincipal[tabState]
                                            ?.midias[0]?.descricaoStatusMidia ===
                                          "BLOQUEADO_ENTREGA"
                                          ? MdCreditCard
                                          : MdCreditCardOff
                                      }
                                      color={
                                        conta?.idProduto === 1
                                          ? window.config.tenant === "Jae"
                                            ? "#55CAC1"
                                            : "#2A85BD"
                                          : conta.idProduto === 2 ||
                                            conta?.idProduto === 6
                                            ? "#000"
                                            : "#E5B02D"
                                      }
                                      w="24px"
                                      h="24px"
                                    />
                                  }
                                />

                                <Text
                                  fontSize="sm"
                                  fontWeight="500"
                                  color={textColor}
                                >
                                  {midiasContaPrincipal[tabState]?.midias[0]
                                    ?.descricaoStatusMidia === "BLOQUEADA" ||
                                    midiasContaPrincipal[tabState]?.midias[0]
                                      ?.descricaoStatusMidia ===
                                    "BLOQUEADA_SUSPEITA_FRAUDE" ||
                                    midiasContaPrincipal[tabState]?.midias[0]
                                      ?.descricaoStatusMidia ===
                                    "BLOQUEADO_ENTREGA"
                                    ? "Desbloquear"
                                    : "Bloquear"}
                                </Text>
                              </Flex>
                              <Flex
                                direction="column"
                                align="center"
                                me={{
                                  base: "22px",
                                  md: "40px",
                                  "2xl": "36px",
                                }}
                              >
                                <IconButton
                                  aria-label="Transfer"
                                  borderRadius="50%"
                                  _hover={bgIconHover}
                                  _active={bgIconFocus}
                                  _focus={bgIconFocus}
                                  w="56px"
                                  h="56px"
                                  mb="5px"
                                  boxShadow={shadow}
                                  onClick={onModalMotivo}
                                  icon={
                                    <Icon
                                      as={MdCancelPresentation}
                                      color={redIcon}
                                      w="24px"
                                      h="24px"
                                    />
                                  }
                                />
                                <Text
                                  fontSize="sm"
                                  fontWeight="500"
                                  color={textColor}
                                >
                                  Cancelar{" "}
                                </Text>
                              </Flex>
                            </>
                          ) : midiasContaPrincipal[tabState]?.midias[0]
                            ?.descricaoStatusMidia === "CANCELADA" &&
                            usoIndevido === false ? (
                            <Flex
                              direction="column"
                              justify={"center"}
                              align={"center"}
                              me={{ base: "22px", md: "40px", "2xl": "36px" }}
                            >
                              <IconButton
                                aria-label="Transfer"
                                borderRadius="50%"
                                //bg={bgIconButton}
                                _hover={bgIconHover}
                                _active={bgIconFocus}
                                _focus={bgIconFocus}
                                onClick={onChange2Via}
                                w="56px"
                                h="56px"
                                mb="5px"
                                boxShadow={shadow}
                                icon={
                                  <Icon
                                    as={MdCreditCard}
                                    color={greenIcon}
                                    w="24px"
                                    h="24px"
                                  />
                                }
                              />
                              <Text
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                ml={"-2"}
                              >
                                Pedir 2º via{" "}
                              </Text>
                              <Text
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                ml={"-2"}
                              >
                                Cartão está cancelado, o cliente pode pedir a 2º
                                via!
                              </Text>
                            </Flex>
                          ) : null}
                        </Flex>
                      </>
                    ) : null}
                  </Flex>
                )}
                <Modal
                  isOpen={modalCancelamento}
                  onClose={onChangeModalCancelamento}
                  size={"sm"}
                >
                  <ModalOverlay />
                  <ModalContent alignSelf={"center"}>
                    <ModalHeader>
                      {bloqueioModal
                        ? midiasContaPrincipal[tabState]?.midias[0]
                          ?.descricaoStatusMidia === "BLOQUEADA" ||
                          midiasContaPrincipal[tabState]?.midias[0]
                            ?.descricaoStatusMidia ===
                          "BLOQUEADA_SUSPEITA_FRAUDE" ||
                          midiasContaPrincipal[tabState]?.midias[0]
                            ?.descricaoStatusMidia === "BLOQUEADO_ENTREGA"
                          ? "Desbloqueio de cartão"
                          : "Bloqueio de cartão"
                        : "Selecione o motivo do cancelamento."}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                      <Flex
                        justify="flex-start"
                        h={"132px"}
                        w={"623px"}
                        mt={"12px"}
                        mb={"-62px"}
                      >
                        <Stack>
                          {IsEmpty(motivos) ? (
                            <Flex
                              justify="center"
                              direction="row"
                              mt={"-15px"}
                              justifyItems={"center"}
                              alignItems={"center"}
                            >
                              <Text
                                color={redIcon}
                                fontSize="sm"
                                lineHeight="100%"
                              >
                                <Icon
                                  as={MdError}
                                  width="20px"
                                  height="20px"
                                  color="inherit"
                                />{" "}
                                Erro ao carregar motivos{" "}
                              </Text>
                            </Flex>
                          ) : null}
                          {!bloqueioModal ? (
                            <Select
                              isRequired={true}
                              id="lojas"
                              name="lojasApi"
                              h="44px"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="16px"
                              defaultValue={motivoSelect}
                              onChange={(e) =>
                                handleChangeSelectCancelamentoMotivo(e)
                              }
                            >
                              <option value="">
                                Selecione o motivo cancelamento
                              </option>
                              {motivos.map((option, index) =>
                                motivos ? (
                                  <option value={option.id} key={index}>
                                    {option.descricao}
                                  </option>
                                ) : null,
                              )}
                            </Select>
                          ) : (
                            <Flex justify="center" direction="row" mt={"5px"}>
                              <Text
                                color={textColor}
                                fontSize="md"
                                lineHeight="100%"
                              >
                                {midiasContaPrincipal[tabState]?.midias[0]
                                  ?.descricaoStatusMidia === "BLOQUEADA" ||
                                  midiasContaPrincipal[tabState]?.midias[0]
                                    ?.descricaoStatusMidia ===
                                  "BLOQUEADA_SUSPEITA_FRAUDE" ||
                                  midiasContaPrincipal[tabState]?.midias[0]
                                    ?.descricaoStatusMidia === "BLOQUEADO_ENTREGA"
                                  ? "Confirma o desbloqueio do cartão:"
                                  : "Confirma o bloqueio do cartão:"}
                                <Text
                                  mt={"5px"}
                                  color={textColor}
                                  fontSize="lg"
                                  fontWeight={"700"}
                                  lineHeight="100%"
                                >
                                  {maskNumeroMidia(
                                    midiasContaPrincipal[tabState]?.midias[0]
                                      ?.numeroLogico,
                                  )}{" "}
                                </Text>
                              </Text>
                            </Flex>
                          )}

                          {/* getListaMotivosCancelamento */}
                        </Stack>
                      </Flex>
                    </ModalBody>
                    <ModalFooter>
                      <Flex justify="center" direction="row">
                        <Button
                          alignSelf={"flex-end"}
                          leftIcon={<MdOutlineClose />}
                          mr="25px"
                          variant="brand"
                          width={"180px"}
                          height={"40px"}
                          bgColor="red.500"
                          loadingText="Aguarde.."
                          disabled={IsEmpty(motivos) ? true : false}
                          onClick={
                            !bloqueioModal
                              ? cancelarCartao
                              : midiasContaPrincipal[tabState]?.midias[0]
                                ?.descricaoStatusMidia === "BLOQUEADA" ||
                                midiasContaPrincipal[tabState]?.midias[0]
                                  ?.descricaoStatusMidia ===
                                "BLOQUEADA_SUSPEITA_FRAUDE" ||
                                midiasContaPrincipal[tabState]?.midias[0]
                                  ?.descricaoStatusMidia ===
                                "BLOQUEADO_ENTREGA"
                                ? desbloqueioCartao
                                : bloqueioCartao
                          }
                          isLoading={loadingCancelamento}
                        >
                          {bloqueioModal ? "Confimar" : "Cancelar cartão"}
                        </Button>
                        <Button
                          alignSelf={"flex-end"}
                          variant="brand"
                          width={"130px"}
                          height={"40px"}
                          onClick={onChangeModalCancelamento}
                        >
                          Fechar
                        </Button>
                      </Flex>
                    </ModalFooter>
                  </ModalContent>
                </Modal>
                <Modal
                  isOpen={modalAssociarCartao}
                  onClose={onCloseModalAssociarCartao}
                  size={"md"}
                >
                  <ModalOverlay />
                  <ModalContent alignSelf={"center"} h={"550px"}>
                    <ModalHeader>Associar Cartão</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                      {window.config.tenant !== "Partiu" && (
                        <Flex justify="center" mt={"-10px"}>
                          <img
                            src={
                              "https://io.billingpay.com.br/bp/img/cartaoAssociar.jpg"
                            }
                            alt="Cartão Associar"
                            width={"80%"}
                          />
                        </Flex>
                      )}
                      <Flex
                        justify="flex-start"
                        h={"132px"}
                        w={"623px"}
                        mt={"2px"}
                        mb={"-62px"}
                        direction={"column"}
                      >
                        <InputField
                          isRequired={true}
                          mb="20px"
                          id="numeroCartao"
                          inputmode="numeric"
                          label="Número do cartão"
                          value={numeroCartaoAssociado.replace(/[^0-9-]/g, "")}
                          w={"223px"}
                          onChange={(e: {
                            target: { value: React.SetStateAction<string> };
                          }) =>
                            setNumeroCartaoAssociado(
                              maskNumeroMidiaAssociada(
                                removerTracos(e.target.value),
                              ),
                            )
                          }
                        />
                      </Flex>
                    </ModalBody>
                    <ModalFooter>
                      <Flex justify="center" direction="row" mt={"15px"}>
                        <Button
                          alignSelf={"flex-end"}
                          leftIcon={<MdCompareArrows />}
                          mr="25px"
                          variant="brand"
                          width={"180px"}
                          height={"40px"}
                          disabled={
                            numeroCartaoAssociado.length < 19 ? true : false
                          }
                          onClick={() =>
                            associarCartao(numeroCartaoAssociado, dataUser)
                          }
                          isLoading={loadingAssociar}
                        >
                          {"Associar cartão"}
                        </Button>
                        <Button
                          alignSelf={"flex-end"}
                          variant="brand"
                          width={"130px"}
                          height={"40px"}
                          onClick={onCloseModalAssociarCartao}
                        >
                          Fechar
                        </Button>
                      </Flex>
                    </ModalFooter>
                  </ModalContent>
                </Modal>
                <Flex
                  justify="space-between"
                  direction="row"
                  align={"center"}
                  me={{ base: "22px", md: "40px", "2xl": "36px" }}
                  w={"100%"}
                >
                  {window.config.tenant == "macae" ? (
                    <Text fontSize="lg" color={textColor} fontWeight="700">
                      Extrato{" "}
                      {showFixedDate ? (
                        window.config.tenant == "macae" && (
                          <Text
                            fontSize="sm"
                            color={textColor}
                            fontWeight="300"
                          >
                            {getLabelConsultaSelecionada()}
                          </Text>
                        )
                      ) : (
                        <Text fontSize="md" color={textColor} fontWeight="300">
                          {maskDataHistoricoSemHora(
                            selectedDateRange.startDate,
                          )}{" "}
                          à{" "}
                          {maskDataHistoricoSemHora(selectedDateRange.endDate)}
                        </Text>
                      )}
                    </Text>
                  ) : (
                    <Text fontSize="lg" color={textColor} fontWeight="700">
                      Extrato{" "}
                    </Text>
                  )}

                  <IconButton
                    //isDisabled={!disableDataVt}
                    aria-label="Top"
                    borderRadius="50%"
                    mb="5px"
                    boxShadow={shadow}
                    icon={
                      <Icon
                        as={MdDateRange}
                        w="24px"
                        h="24px"
                        onClick={onChangeModalData}
                      />
                    }
                  />
                </Flex>
                {window.config.tenant !== "macae" ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      marginTop: 10,
                      background: "#fafafa",
                      padding: 10,
                    }}
                  >
                    <Button
                      colorScheme={
                        periodoSelecionado === PeriodosConsulta.um_mes
                          ? "teal"
                          : "brand"
                      }
                      onClick={() => {
                        clickRangeButton(PeriodosConsulta.um_mes);
                      }}
                    >
                      1 mês
                    </Button>
                    <Button
                      colorScheme={
                        periodoSelecionado === PeriodosConsulta.tres_meses
                          ? "teal"
                          : "brand"
                      }
                      onClick={() => {
                        clickRangeButton(PeriodosConsulta.tres_meses);
                      }}
                    >
                      3 meses
                    </Button>
                    <Button
                      colorScheme={
                        periodoSelecionado === PeriodosConsulta.seis_meses
                          ? "teal"
                          : "brand"
                      }
                      onClick={() => {
                        clickRangeButton(PeriodosConsulta.seis_meses);
                      }}
                    >
                      6 meses
                    </Button>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      marginTop: 10,
                      background: "#fafafa",
                      padding: 10,
                    }}
                  >
                    <Button
                      colorScheme={
                        periodoSelecionado === PeriodosConsulta.quinze_dias
                          ? "teal"
                          : "brand"
                      }
                      onClick={() => {
                        setShowFixedDate(true);
                        setPeriodoSelecionado(PeriodosConsulta.quinze_dias);
                        ExtratoMacae(1, dateRangeApi, dataUser.codigo);
                      }}
                      _hover={{
                        bg: "purple.700", // cor quando o mouse passar por cima
                        color: "white", // opcional: muda cor do texto
                      }}
                    >
                      15 dias
                    </Button>
                    <Button
                      colorScheme={
                        periodoSelecionado === PeriodosConsulta.trinta_dias
                          ? "teal"
                          : "brand"
                      }
                      onClick={() => {
                        setShowFixedDate(true);
                        setPeriodoSelecionado(PeriodosConsulta.trinta_dias);
                        ExtratoMacae(2, dateRangeApi, dataUser.codigo);
                      }}
                      _hover={{
                        bg: "purple.700", // cor quando o mouse passar por cima
                        color: "white", // opcional: muda cor do texto
                      }}
                    >
                      30 dias
                    </Button>
                    <Button
                      colorScheme={
                        periodoSelecionado === PeriodosConsulta.sessenta_dias
                          ? "teal"
                          : "brand"
                      }
                      onClick={() => {
                        setShowFixedDate(true);
                        setPeriodoSelecionado(PeriodosConsulta.sessenta_dias);
                        ExtratoMacae(3, dateRangeApi, dataUser.codigo);
                      }}
                      _hover={{
                        bg: "purple.700", // cor quando o mouse passar por cima
                        color: "white", // opcional: muda cor do texto
                      }}
                    >
                      60 dias
                    </Button>
                    <Button
                      colorScheme={
                        periodoSelecionado === PeriodosConsulta.noventa_dias
                          ? "teal"
                          : "brand"
                      }
                      onClick={() => {
                        setShowFixedDate(true);
                        setPeriodoSelecionado(PeriodosConsulta.noventa_dias);
                        ExtratoMacae(4, dateRangeApi, dataUser.codigo);
                      }}
                      _hover={{
                        bg: "purple.700", // cor quando o mouse passar por cima
                        color: "white", // opcional: muda cor do texto
                      }}
                    >
                      90 dias
                    </Button>
                  </div>
                )}

                {!IsEmpty(midiasContaPrincipal) &&
                  window.config.tenant !== "macae" && (
                    <Flex
                      justify={{ base: "center", md: "end" }}
                      direction="row"
                      align={"center"}
                      w={"100%"}
                      wrap="wrap"
                    >
                      <Text
                        fontSize="md"
                        color={textColor}
                        fontWeight="700"
                        mr={"15px"}
                        mb={{ base: "10px", md: "0px" }}
                      >
                        Filtros:
                      </Text>
                      <Tabs isManual variant="enclosed" mb={"15px"} w={{ base: "100%", md: "auto" }}>
                        <TabList justifyContent={{ base: "center", md: "flex-start" }}>
                          <Tab onClick={() => onPesquisarTodos(dateRangeApi)}>
                            {" "}
                            <Text
                              fontSize="sm"
                              color={textColor}
                              fontWeight="300"
                            >
                              Todos
                            </Text>
                          </Tab>
                          <Tab
                            onClick={() => pesquisaCredito()}
                            _selected={{ color: "white", bg: "green.400" }}
                          >
                            {" "}
                            <Text fontSize="sm" fontWeight="300">
                              <Icon as={MdOutlineAttachMoney} /> Crédito
                            </Text>
                          </Tab>
                          <Tab
                            onClick={() => pesquisaUtilizacao()}
                            _selected={{ color: "white", bg: "red.400" }}
                          >
                            {" "}
                            <Text fontSize="sm" fontWeight="300">
                              <Icon as={MdOutlineRemoveCircleOutline} />{" "}
                              Utilização
                            </Text>
                          </Tab>
                        </TabList>
                        <TabIndicator
                          mt="-1.5px"
                          height="2px"
                          bg="blue.500"
                          borderRadius="0px"
                          border={"0px"}
                        />
                      </Tabs>
                    </Flex>
                  )}
                {somaPesquisaUtilizacao !== 0 &&
                  window.config.tenant !== "macae" && (
                    <Flex
                      justify={{ base: "center", md: "flex-end" }}
                      direction="row"
                      ml={{ base: "0px", md: "-15px" }}
                      align={"center"}
                      me={{ base: "0px", md: "82px", "2xl": "36px" }}
                      w={"100%"}
                    >
                      <Text fontSize="sm" color={textColor} fontWeight="700">
                        Total período:{" "}
                      </Text>

                      <Text
                        fontSize="md"
                        color={
                          somaPesquisaUtilizacao < 0 ? "red.400" : "green.400"
                        }
                        fontWeight="700"
                        style={{ marginLeft: "5px" }}
                      >
                        {formatarParaMoeda(somaPesquisaUtilizacao)}
                      </Text>
                    </Flex>
                  )}
                <Divider mt="10px" />
                {window.config.tenant !== "macae" ? (
                  <Box
                    position={"static"}
                    overflowX="hidden"
                    overflowY={!IsEmpty(historicoExtrato) ? "scroll" : "hidden"}
                    maxW="100%"
                    w="100%"
                    h={historicoExtrato.length < 6 ? "45vh" : "80vh"}
                    whiteSpace="nowrap"
                    pb="17px"
                  >
                    {loadingDataTransacoes ? (
                      <p style={{ padding: 10 }}>Carregando...</p>
                    ) : !IsEmpty(historicoExtrato) ? (
                      historicoExtrato.map((extrato, i) => (
                        <Flex
                          key={i}
                          alignSelf={"center"}
                          justifyItems={"center"}
                          backgroundColor={
                            i % 2 === 0 ? "blackAlpha.20" : "blackAlpha.50"
                          }
                        >
                          <Transaction extrato={extrato} />
                        </Flex>
                      ))
                    ) : (
                      <Text
                        fontSize="md"
                        color={redIcon}
                        fontWeight="500"
                        align={"center"}
                        mt={"9px"}
                      >
                        Sem dados disponíveis para pesquisa.
                      </Text>
                    )}
                  </Box>
                ) : (
                  <Box
                    position={"static"}
                    overflowX="hidden"
                    overflowY={
                      !IsEmpty(historicoExtratoMacae) ? "scroll" : "hidden"
                    }
                    maxW="100vw"
                    h={historicoExtratoMacae.length < 6 ? "45vh" : "80vh"}
                    whiteSpace="nowrap"
                    pb="17px"
                  >
                    {loadingDataTransacoes ? (
                      <p style={{ padding: 10 }}>Carregando...</p>
                    ) : !IsEmpty(historicoExtratoMacae) ? (
                      <>
                        {!IsEmpty(historicoExtratoMacae) &&
                          historicoExtratoMacae.map((extrato, i) => (
                            <Flex
                              key={extrato.idCompra || i}
                              alignSelf="center"
                              justifyItems="center"
                              w="100%"
                              bg={
                                i % 2 === 0 ? "blackAlpha.20" : "blackAlpha.50"
                              }
                              borderRadius="md"
                            >
                              <TransactionMacae extrato={extrato} />
                            </Flex>
                          ))}
                      </>
                    ) : (
                      <Text
                        fontSize="md"
                        color={redIcon}
                        fontWeight="500"
                        textAlign="center"
                        mt="9px"
                      >
                        Sem dados disponíveis para pesquisa.
                      </Text>
                    )}
                  </Box>
                )}
                <Divider mb="10px" />
              </TabPanel>
            ))}
            ;
          </TabPanels>
        </Tabs>
      </Card>
      <Modal
        isOpen={isOpenModalBloqueioIndevido}
        onClose={onChangeModalBloqueioIndevido}
        motionPreset="none"
        size={"3xl"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Desbloqueio de conta</ModalHeader>
          <ModalCloseButton />

          <ModalBody mt={3}>
            <span>Motivo</span>
            <Select
              width="100%"
              value={motivo}
              onChange={(event) => {
                const newValue = event.target.value;
                if (newValue === "---") {
                  setMotivo(null);
                } else {
                  setMotivo(Number(event.target.value));
                }
              }}
              mt={1}
              mb={5}
              id={"motivoSelect"}
            >
              {modalType === MODAL_ENUM.bloquearSaldo ||
                modalType === MODAL_ENUM.bloquearConta ||
                modalType === MODAL_ENUM.bloquearMidia ? null : (
                <>
                  <option value={null}> --- </option>
                  {listaDeMotivos.listaMotivoDesbloqueio.map((motivo) => (
                    <option key={motivo.id} value={motivo.id}>
                      {motivo.descricao}
                    </option>
                  ))}
                </>
              )}
            </Select>
            <span>Justificativa</span>
            <Textarea
              id="justificativaTextarea"
              value={justificativa}
              variant="outline"
              placeholder="Justificativa..."
              mt={1}
              onChange={(e) => setJustificativa(e.target.value)}
            />{" "}
            <div className="mt-4 mb-2">
              <span>Documento</span>
              <Input
                type={"file"}
                className="mt-2 mb-2 p-4"
                style={{ height: 60 }}
                onChange={handleFileChange}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              id="confirmButtonModal"
              // disabled={motivo === null || justificativa === ""}
              colorScheme="blue"
              mr={3}
              isLoading={loading}
              onClick={() => {
                handleClickConfirmModal();
              }}
            >
              Confirmar
            </Button>
            <Button
              id="cancelButtonModal"
              colorScheme="red"
              isLoading={loading}
              onClick={() => onChangeModalBloqueioIndevido()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
